// jshint esversion: 6
//faqapp.js - v1.2.5 (servisson-faq)
//cache-bust 249
//

if (!String.prototype.trim) {
    String.prototype.trim = function() {
        return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
    };
}
if (typeof faqApp === "undefined") {
    var faqApp = {
        func: {},
        vars: {},
        cmb: {},
        lc: {},
        oneTrust: {},
        obj: {}
    };
}
faqApp.vars.onSearchPage = false;
faqApp.vars.brand = '';
faqApp.vars.language = '';
faqApp.vars.validation = '';
faqApp.vars.init = 0;
faqApp.vars.host = 'https://cslobby-api-qa.servisson.com'; //Replaced by grunt-replace <api_host_url>
faqApp.vars.lastfaq = 0;
faqApp.vars.lastcat = 0;
faqApp.vars.active = "faq_nav_topten";
faqApp.vars.gtm = true;
faqApp.vars.mobile = false;
faqApp.vars.device = "desktop";
faqApp.vars.secondLevelDomain = "";
faqApp.vars.gdpr_data = 1;
faqApp.vars.window_size = 0;
faqApp.cmb.on = 1; // default on
faqApp.cmb.permit = false;
faqApp.lc.permit = false;
faqApp.oneTrust.permit = false;
faqApp.obj.events = {};
faqApp.obj.uri = {};
faqApp.obj.translation = {};
faqApp.obj[404] = {
    en: "This page is having a problem loading. Please try again.",
    sv: "Problem med att läsa in den här sidan. Vänligen försök igen.",
    nb: "Det er problemer med å laste inn denne siden. Vennligst prøv igjen.",
    fi: "Tämän sivun lataamisessa on ongelma. Yritä uudestaan.",
    cs: "Tato stránka má problémy s načtením. Prosíme, zkuste znovu.",
    de: "Beim Laden dieser Seite ist ein Problem aufgetreten. Bitte versuche es erneut.",
    nl: "Deze pagina heeft een probleem met laden, probeer het alstublieft opnieuw.",
    pl: "Wystąpiły problemy podczas ładowania tej strony. Prosimy o ponowną próbę.",
    lv: "Šai lapai ir ielādes problēma. Lūdzu mēģiniet vēlreiz.",
    it: "Problema di caricamento della pagina. Riprova.",
    pt: "Esta página apresenta um problema ao carregar. Por favor tente novamente",
    es: "Esta página tiene problemas para cargarse, por favor intente nuevamente.",
    pe: "Esta página tiene problemas para cargarse, por favor intente nuevamente.",
    'pt-br': "Esta página está com problemas para carregar. Por favor, tente novamente.",
    fr: "Erreur durant le chargement de cette page. Veuillez réessayer.",
    et: "Selle lehe laadimisega on probleeme. Proovige uuesti.",
    ru: "На этой странице возникла ошибка при загрузке. Повторите попытку.",
    cl: "Esta página tiene problemas para cargarse, por favor intente nuevamente.",
    ca: "This page is having a problem loading. Please try again.",
    dk: "This page is having a problem loading. Please try again.",
    nz: "This page is having a problem loading. Please try again.",
    in: "This page is having a problem loading. Please try again.",
    jp: "このページの読み込みに問題があります。 もう一度お試しください。",
    gr: "This page is having a problem loading. Please try again.",
    hr: "This page is having a problem loading. Please try again.",
    co: "This page is having a problem loading. Please try again.",
    is: "This page is having a problem loading. Please try again.",
    eu: "This page is having a problem loading. Please try again.",
    sr: "This page is having a problem loading. Please try again.",
    cstech: "This page is having a problem loading. Please try again.",
    kk: "This page is having a problem loading. Please try again.",
    lt: "This page is having a problem loading. Please try again.",

};
faqApp.obj[503] = {
    en: "Something went wrong. Please try again.",
    sv: "Något gick fel. Vänligen försök igen.",
    nb: "Noe gikk galt. Vennligst prøv igjen.",
    fi: "Jokin meni pieleen. Yritä uudestaan.",
    cs: "Vyskyla se chyba. Prosíme, zkuste znovu.",
    de: "Etwas ist schiefgegangen. Bitte versuche es erneut.",
    nl: "Er is iets fout gegaan, probeer het alstublieft opnieuw.",
    pl: "Wystąpił błąd. Prosimy o ponowną próbę.",
    lv: "Ir notikusi kļūda. Lūdzu mēģiniet vēlreiz.",
    it: "Qualcosa è andato storto. Riprova.",
    pt: "Ocorreu um erro. Por favor tente novamente.",
    es: "Error en el servidor, por favor intente nuevamente.",
    pe: "Error en el servidor, por favor intente nuevamente.",
    'pt-br': "Algo deu errado. Por favor, tente novamente.",
    fr: "Une erreur s’est produite. Veuillez réessayer.",
    et: "Midagi läks valesti. Proovige uuesti.",
    ru: "Что-то пошло не так. Повторите попытку.",
    cl: "Error en el servidor, por favor intente nuevamente.",
    ca: "Something went wrong. Please try again.",
    dk: "Something went wrong. Please try again.",
    nz: "Something went wrong. Please try again.",
    in: "Something went wrong. Please try again.",
    jp: "何らかの問題が発生しました。 もう一度お試しください。",
    gr: "Something went wrong. Please try again.",
    hr: "Something went wrong. Please try again.",
    co: "Something went wrong. Please try again.",
    is: "Something went wrong. Please try again.",
    eu: "Something went wrong. Please try again.",
    sr: "Something went wrong. Please try again.",
    cstech: "This page is having a problem loading. Please try again.",
    kk: "This page is having a problem loading. Please try again.",
    lt: "Something went wrong. Please try again.",

};
faqApp.obj.uri.templateUrl = {
    brand: {
        bet: "../assets/template/bet.template",
        bsf: "../assets/template/bsf.template",
        nrb: "../assets/template/nrb.template",
        stc: "../assets/template/stc.template",
        sva: "../assets/template/sva.template",
        sua: "../assets/template/sua.template",
        noa: "../assets/template/noa.template",
        ceu: "../assets/template/ceu.template",
        mrs: "../assets/template/mrs.template", //cache-bust this template,
        lrt: "../assets/template/lrt.template",
        cwn: "../assets/template/cwn.template",
        'bsf-ee': "../assets/template/bsf-ee.template",
        'bsf-lv': "../assets/template/bsf-lv.template",
        loc: "../assets/template/lyc.template", //cache-bust this template,
        rcb: "../assets/template/rcb.template",
        jlc: "../assets/template/jlc.template", //cache-bust this template
        spc: "../assets/template/spc.template", //cache-bust this template
        jkp: "../assets/template/jkp.template", //cache-bust this template
        'nrb-dk': "../assets/template/nrb-dk.template", //cache-bust this template
        'bet-es': "../assets/template/bet-es.template", //cache-bust this template
        'spc-ee': "../assets/template/spc-ee.template", //cache-bust this templatee
        'rzk': "../assets/template/rzk.template",
        'gts': "../assets/template/gts.template",
        'gtx': "../assets/template/gts.template",
        'kbo': "../assets/template/kbo.template",
        'trl': "../assets/template/trl.template",
        'rzk-es': "../assets/template/rzk-es.template",
        'csn-dk': "../assets/template/csn-dk.template",
        'ahs': "../assets/template/ahs.template",
        'bet-gr': "../assets/template/bet-gr.template",
        'bet-br': "../assets/template/bet-br.template",
        'bsf-ke': "../assets/template/bsf-ke.template",
        'euc': "../assets/template/euc.template",
        'rcb-de': "../assets/template/rcb-de.template",
        'rzk-hr': "../assets/template/rzk-hr.template",
        'cbt': "../assets/template/cbt.template",
        'bet-de': "../assets/template/bet-de.template",
        'bet-ar': "../assets/template/bet-ar.template",
        'jko': "../assets/template/jko.template",
        'dvb': "../assets/template/dvb.template",
        'orj': "../assets/template/orj.template",
        'krn': "../assets/template/krn.template",
        'bet-arp': "../assets/template/bet-arp.template",
        'bsf-crd': "../assets/template/bsf-crd.template",
        'bet-nl': "../assets/template/bet-nl.template",
        'bet-co': "../assets/template/bet-co.template",
        'bet-mx': "../assets/template/bet-mx.template",
        'inb': "../assets/template/inb.template",
        'bsf-ont': "../assets/template/bsf-ont.template",
        'bet-cz': "../assets/template/bet-cz.template",
        'nda': "../assets/template/nda.template",
        'rzk-rs': "../assets/template/rzk-rs.template",
        'rcb-dev': "../assets/template/rcb-dev.template",
        'jlc-ee': "../assets/template/jlc-ee.template",
        'bet-be': "../assets/template/bet-be.template",
        'bet-dk': "../assets/template/bet-dk.template",
        'bet-it': "../assets/template/bet-it.template",
        'bet-cba': "../assets/template/bet-cba.template",
        'bet-pe': "../assets/template/bet-pe.template",
        'bsf-pe': "../assets/template/bsf-pe.template",
        'acb': "../assets/template/acb.template",
        'bth': "../assets/template/bth.template",
        'btd': "../assets/template/btd.template",
        'bet-kz': "../assets/template/bet-kz.template",
        'bet-py': "../assets/template/bet-py.template",
        'bet-bbr': "../assets/template/bet-bbr.template",
        'bet-uk': "../assets/template/bet-uk.template",
        'crc': "../assets/template/crc.template",
        'bet-lt': "../assets/template/bet-lt.template",

    },
    saForm: {
        cs: "../assets/template/sa-form-cs.template",
        de: "../assets/template/sa-form-de.template",
        en: "../assets/template/sa-form-en.template",
        fi: "../assets/template/sa-form-fi.template",
        it: "../assets/template/sa-form-it.template",
        lv: "../assets/template/sa-form-lv.template",
        nb: "../assets/template/sa-form-nb.template", //cache-bust this template
        pl: "../assets/template/sa-form-pl.template",
        sv: "../assets/template/sa-form-sv.template",
        es: "../assets/template/sa-form-es.template",
        pe: "../assets/template/sa-form-pe.template", //cache-bust this template
        nl: "../assets/template/sa-form-nl.template",
        'pt-br': "../assets/template/sa-form-pt-br.template",
        et: "../assets/template/sa-form-et.template",
        ru: "../assets/template/sa-form-ru.template",
        cl: "../assets/template/sa-form-cl.template",
        ca: "../assets/template/sa-form-ca.template", //cache-bust this template
        dk: "../assets/template/sa-form-dk.template", //cache-bust this template
        nz: "../assets/template/sa-form-nz.template",
        in: "../assets/template/sa-form-in.template",
        uk: "../assets/template/sa-form-uk.template",
        jp: "../assets/template/sa-form-jp.template",
        gr: "../assets/template/sa-form-gr.template",
        hr: "../assets/template/sa-form-hr.template",
        co: "../assets/template/sa-form-co.template",
        is: "../assets/template/sa-form-is.template",
        eu: "../assets/template/sa-form-eu.template",
        sr: "../assets/template/sa-form-sr.template",
        kk: "../assets/template/sa-form-kk.template",
        lt: "../assets/template/sa-form-lt.template",

    },
    saResult: {
        cs: "../assets/template/sa-result-cs.template",
        de: "../assets/template/sa-result-de.template",
        en: "../assets/template/sa-result-en.template",
        fi: "../assets/template/sa-result-fi.template",
        it: "../assets/template/sa-result-it.template",
        lv: "../assets/template/sa-result-lv.template",
        nb: "../assets/template/sa-result-nb.template",
        pl: "../assets/template/sa-result-pl.template",
        sv: "../assets/template/sa-result-sv.template",
        es: "../assets/template/sa-result-es.template",
        pe: "../assets/template/sa-result-pe.template", //cache-bust this template
        nl: "../assets/template/sa-result-nl.template",
        'pt-br': "../assets/template/sa-result-pt-br.template",
        et: "../assets/template/sa-result-et.template", //cache-bust this template
        ru: "../assets/template/sa-result-ru.template",
        cl: "../assets/template/sa-result-cl.template",
        ca: "../assets/template/sa-result-ca.template", //cache-bust this template
        dk: "../assets/template/sa-result-dk.template", //cache-bust this templatee
        nz: "../assets/template/sa-result-nz.template",
        in: "../assets/template/sa-result-in.template",
        uk: "../assets/template/sa-result-uk.template",
        jp: "../assets/template/sa-result-jp.template",
        gr: "../assets/template/sa-result-gr.template",
        hr: "../assets/template/sa-result-hr.template",
        co: "../assets/template/sa-result-co.template",
        is: "../assets/template/sa-result-is.template",
        eu: "../assets/template/sa-result-eu.template",
        sr: "../assets/template/sa-result-sr.template",
        kk: "../assets/template/sa-result-kk.template",
        lt: "../assets/template/sa-result-lt.template",

    },
    complaintForm: {
        en: "../assets/template/complaint-form/betsson-en-complaint.template",
        gr: "../assets/template/complaint-form/betsson-gr-complaint.template",
        pe: "../assets/template/complaint-form/pe-complaint.template",
    },
    bsfDepositOptions: {
        de: "../assets/template/deposit-options/betsafe/de.template",
        en: "../assets/template/deposit-options/betsafe/en.template",
        es: "../assets/template/deposit-options/betsafe/es.template",
        fi: "../assets/template/deposit-options/betsafe/fi.template",
        nb: "../assets/template/deposit-options/betsafe/nb.template",
        pe: "../assets/template/deposit-options/betsafe/pe.template",
        pl: "../assets/template/deposit-options/betsafe/pl.template",
        sv: "../assets/template/deposit-options/betsafe/sv.template",
        ca: "../assets/template/deposit-options/betsafe/ca.template"
    },
    betDepositOptions: {
        de: "../assets/template/deposit-options/betsson/de.template", //cache-bust this template
        en: "../assets/template/deposit-options/betsson/en.template", //cache-bust this template
        es: "../assets/template/deposit-options/betsson/es.template", //cache-bust this template
        fi: "../assets/template/deposit-options/betsson/fi.template", //cache-bust this template
        nb: "../assets/template/deposit-options/betsson/nb.template", //cache-bust this template
        pe: "../assets/template/deposit-options/betsson/pe.template", //cache-bust this template
        pl: "../assets/template/deposit-options/betsson/pl.template", //cache-bust this template
        sv: "../assets/template/deposit-options/betsson/sv.template", //cache-bust this template
        cl: "../assets/template/deposit-options/betsson/cl.template", //cache-bust this template
        gr: "../assets/template/deposit-options/betsson/gr.template" //cache-bust this template

    },
    ceuDepositOptions: {
        de: "../assets/template/deposit-options/casinoeuro/de.template", //cache-bust this template
        en: "../assets/template/deposit-options/casinoeuro/en.template", //cache-bust this template
        es: "../assets/template/deposit-options/casinoeuro/es.template", //cache-bust this template
        fi: "../assets/template/deposit-options/casinoeuro/fi.template", //cache-bust this template
        nb: "../assets/template/deposit-options/casinoeuro/nb.template", //cache-bust this template
        pl: "../assets/template/deposit-options/casinoeuro/pl.template", //cache-bust this template
    },
    nrbDepositOptions: {
        de: "../assets/template/deposit-options/nordicbet/de.template",
        en: "../assets/template/deposit-options/nordicbet/en.template",
        fi: "../assets/template/deposit-options/nordicbet/fi.template",
        nb: "../assets/template/deposit-options/nordicbet/nb.template",
        sv: "../assets/template/deposit-options/nordicbet/sv.template"
    },
    nrbDKDepositOptions: {
        dk: "../assets/template/deposit-options/nordicbet/dk.template"
    },
    bsfWithdrawalOptions: {
        de: "../assets/template/withdrawal-options/betsafe/de.template", //cache-bust this template
        en: "../assets/template/withdrawal-options/betsafe/en.template", //cache-bust this template
        es: "../assets/template/withdrawal-options/betsafe/es.template", //cache-bust this template
        fi: "../assets/template/withdrawal-options/betsafe/fi.template", //cache-bust this template
        nb: "../assets/template/withdrawal-options/betsafe/nb.template", //cache-bust this template
        pe: "../assets/template/withdrawal-options/betsafe/pe.template", //cache-bust this template
        pl: "../assets/template/withdrawal-options/betsafe/pl.template", //cache-bust this template
        sv: "../assets/template/withdrawal-options/betsafe/sv.template", //cache-bust this template
        ca: "../assets/template/withdrawal-options/betsafe/ca.template" //cache-bust this template
    },
    betWithdrawalOptions: {
        de: "../assets/template/withdrawal-options/betsson/de.template", //cache-bust this template
        en: "../assets/template/withdrawal-options/betsson/en.template", //cache-bust this template
        es: "../assets/template/withdrawal-options/betsson/es.template", //cache-bust this template
        fi: "../assets/template/withdrawal-options/betsson/fi.template", //cache-bust this template
        nb: "../assets/template/withdrawal-options/betsson/nb.template", //cache-bust this template
        pe: "../assets/template/withdrawal-options/betsson/pe.template", //cache-bust this template
        pl: "../assets/template/withdrawal-options/betsson/pl.template", //cache-bust this template
        sv: "../assets/template/withdrawal-options/betsson/sv.template", //cache-bust this template
        cl: "../assets/template/withdrawal-options/betsson/cl.template", //cache-bust this template
        gr: "../assets/template/withdrawal-options/betsson/gr.template" //cache-bust this template
    },
    ceuWithdrawalOptions: {
        de: "../assets/template/withdrawal-options/casinoeuro/de.template", //cache-bust this template
        en: "../assets/template/withdrawal-options/casinoeuro/en.template", //cache-bust this template
        es: "../assets/template/withdrawal-options/casinoeuro/es.template", //cache-bust this template
        fi: "../assets/template/withdrawal-options/casinoeuro/fi.template", //cache-bust this template
        nb: "../assets/template/withdrawal-options/casinoeuro/nb.template", //cache-bust this template
        pl: "../assets/template/withdrawal-options/casinoeuro/pl.template", //cache-bust this template
    },
    nrbWithdrawalOptions: {
        de: "../assets/template/withdrawal-options/nordicbet/de.template",
        en: "../assets/template/withdrawal-options/nordicbet/en.template",
        fi: "../assets/template/withdrawal-options/nordicbet/fi.template",
        nb: "../assets/template/withdrawal-options/nordicbet/nb.template",
        sv: "../assets/template/withdrawal-options/nordicbet/sv.template"
    },
    nrbDKWithdrawalOptions: {
        dk: "../assets/template/withdrawal-options/nordicbet/dk.template"
    },
};
faqApp.func.Initialize = function(param) {
    faqApp.vars.brand = param.brand.toLowerCase();
    faqApp.vars.language = param.language.toLowerCase();

    if (param.settings && param.settings.type) {
        if (param.settings.type == 'uri') {
            faqApp.obj.uri.uri = true;
            if (param.settings.faquri) {
                faqApp.obj.uri.faquri = param.settings.faquri;
            }
            if (param.settings.faqurl) {
                faqApp.obj.uri.faqurl = param.settings.faqurl;
            }
            if (param.settings.categoryuri) {
                faqApp.obj.uri.categoryuri = param.settings.categoryuri;
            }
            if (param.settings.categoryurl) {
                faqApp.obj.uri.categoryurl = param.settings.categoryurl;
            }
            if (param.settings.searchuri) {
                faqApp.obj.uri.searchuri = param.settings.searchuri;
            }
            if (param.settings.searchurl) {
                faqApp.obj.uri.searchurl = param.settings.searchurl;
            }
            if (typeof param.settings.gtm !== 'undefined') {
                faqApp.vars.gtm = param.settings.gtm;
            }
            if (typeof param.settings.mobile !== 'undefined') {
                faqApp.vars.mobile = param.settings.mobile;
                if (faqApp.vars.mobile) {
                    faqApp.vars.device = "mobile";
                }
            }

            if (window.location.search) {
                var faq_a_uri = window.location.search.slice(1, (window.location.search.length)).split("&");
                $.each(faq_a_uri, function(k, d) {
                    faq_a_temp_uri = d.split("=");
                    faqApp.obj.uri[faq_a_temp_uri[0]] = faq_a_temp_uri[1];
                });
            }
        }
    }
    $('#template').load(faqApp.obj.uri.templateUrl.brand[faqApp.vars.brand], function(response, status, xhr) {
        if (status !== 'error') {
            progressLoader(10);
            url = '/api.php?bi=' + faqApp.vars.brand + '&action=getCategories&device=' + faqApp.vars.device;
            faqApp.func.ajax(url, null, true, function(data) {
                progressLoader(20);
                faqApp.obj.translation = data.translation;
                faqApp.obj.info = data.info;

                url = '/api.php?bi=' + faqApp.vars.brand + '&action=getChatWindowSize';
                faqApp.func.ajax(url, null, true, function(sizeValues) {
                    data.info.livechat_window = sizeValues[0];
                    faqApp.func.pageRender(data.categories, data.topten, data.info);
                });

                // callmeback button textarea
                $('#faq_callmeback').html('<span>' + faqApp.obj.translation.callmeback_lbl + '</span><i class="fa fa-phone"></i>');

                // get second-level domain
                var domain = location.hostname.split('.');
                if(domain.length == 3)
                {
                    faqApp.vars.secondLevelDomain = `${domain[1]}.${domain[2]}`;
                }
                else if(domain.length == 4)
                {
                    faqApp.vars.secondLevelDomain = `${domain[1]}.${domain[2]}.${domain[3]}`;
                }
                else if(domain.length == 5)
                {
                    faqApp.vars.secondLevelDomain = `${domain[1]}.${domain[2]}.${domain[3]}.${domain[4]}`;
                }
                else{
                    console.log("Too many levels in domain");
                }
                // update link to cookie gdpr_settings
                $('#cookie_settings_link').attr("href", data.info.url_cookiesettings);

                // get gdpr switch
                faqApp.func.ajax(`/api.php?action=getGDPRswitch&bi=${faqApp.vars.brand}`, null, false, function(gdpr_data) {
                    // render cookie policy text
                    faqApp.vars.gdpr_data = gdpr_data[0].gdpr_active;
                    if (gdpr_data[0].gdpr_active == 1) {
                        // console.log(`active [${gdpr_data[0].gdpr_active}]`);
                        if (faqApp.func.getCookie('CONSENT')) {
                            // console.log("cookie found");
                            var cookie_consent = JSON.parse(decodeURIComponent(faqApp.func.getCookie('CONSENT')));
                        } else { // if no cookie_consent is found
                            // attach link to cookie policy page
                            faqApp.obj.translation.gdpr_text = faqApp.obj.translation.gdpr_text.replace(/(\[gdpr_policy\])/g, `<a href="${data.info.url_privacyinfo}" target="_blank"> ${faqApp.obj.translation.gdpr_policy}</a>`);
                            // attach link to cookie settings page
                            faqApp.obj.translation.gdpr_text = faqApp.obj.translation.gdpr_text.replace(/(\[gdpr_settings\])/g, `<a href="${data.info.url_cookiesettings}" onclick="faqApp.func.cookiesAcknowledged(0);"> ${faqApp.obj.translation.gdpr_settings}</a>`);
                            // apply cookie text according to device
                            if (window.outerWidth >= 768) {
                                $('#cookie-policy').html('<div class="col-sm-9 col-md-10 col-lg-10 notice-text"> <span>' + faqApp.obj.translation.gdpr_text + '</span></div><div class="cookie-btns"><button type="button" id="cookie-yes" class="btn btn-default" onclick="faqApp.func.cookiesAcknowledged(1);">' + faqApp.obj.translation.accept + '</button></div>');
                            } else {
                                $('#cookie-policy').html('<div class="notice-text"> <span>' + faqApp.obj.translation.gdpr_text + '</span></div><div class="cookie-btns"><button type="button" id="cookie-yes" class="btn btn-default" onclick="faqApp.func.cookiesAcknowledged(1);">' + faqApp.obj.translation.accept + '</button></div>');
                            }
                            // if activity_bar (live chat / e-mail / request callback) is at the bottom of screen
                            // since activity_bar may be independent of device
                            if ($('.activity_bar').offset().top > (window.outerHeight / 2)) { // if activity_bar on bottom
                                $('#cookie-policy').css({
                                    'display': 'block',
                                    'margin-bottom': $('.activity_bar').outerHeight()
                                });
                                $('#cookie-btns').addClass("btn-block");
                                $('#faq_totop').css('top', $('#faq_totop').position().top - $('#cookie-policy').outerHeight());
                                $('#faq_callmeback').css('top', $('#faq_callmeback').position().top - $('#cookie-policy').outerHeight());
                            } else { // if activity_bar on top
                                // push floating buttons upwards temporarily
                                $('#cookie-policy').css('display', 'block');
                                $('#faq_totop').css('top', $('#faq_totop').position().top - $('#cookie-policy').outerHeight());
                                $('#faq_callmeback').css('top', $('#faq_callmeback').position().top - $('#cookie-policy').outerHeight());
                            }
                        }
                    }
                });
            });

            if (param.category) {
                faqApp.func.faqsPerCategory(param.category);
            }
        } else {
            if ($('#ajaxProgressBar')) {
                $('#ajaxProgressBar').removeClass('progress-bar-info').addClass('progress-bar-danger');
                $('#progress--header').html('<i class="fa fa-exclamation-triangle"></i> ' + faqApp.obj[404][faqApp.vars.language]);
            }
        }

        // check if callmeback is allowed on brand/language CB_1
        // Cache bust 1
        if (faqApp.vars.language != 'es') {
            if (!(((faqApp.vars.brand == 'bsf-lv' || faqApp.vars.brand == 'bsf-ee') && (faqApp.vars.language == 'en' || faqApp.vars.language == 'ru')) || (faqApp.vars.brand == 'bet' && faqApp.vars.language == 'pt-br') || (faqApp.vars.brand == 'ahs') || (faqApp.vars.brand == 'bsf-ke') || (faqApp.vars.brand == 'rzk-hr') || (faqApp.vars.brand == 'bet' && faqApp.vars.language == 'cl') || (faqApp.vars.brand == 'cbt') || (faqApp.vars.brand == 'bet-co') || (faqApp.vars.brand == 'bsf' && faqApp.vars.language == 'pe') || (faqApp.vars.brand == 'bsf-crd') || (faqApp.vars.brand == 'euc') || (faqApp.vars.brand == 'inb') || (faqApp.vars.brand == 'bsf-ont') || (faqApp.vars.brand == 'rzk') || (faqApp.vars.brand == 'rzk-hr') || (faqApp.vars.brand == 'gts') || (faqApp.vars.brand == 'kbo') || (faqApp.vars.brand == 'bet' && faqApp.vars.language == 'en') || (faqApp.vars.brand == 'nrb' && faqApp.vars.language == 'eu') || (faqApp.vars.brand == 'bsf' && faqApp.vars.language == 'eu') || (faqApp.vars.brand == 'nda' && faqApp.vars.language == 'eu') || (faqApp.vars.brand == 'rzk-rs') || (faqApp.vars.brand == 'spc-ee' && faqApp.vars.language == 'en') || (faqApp.vars.brand == 'spc-ee' && faqApp.vars.language == 'ru') || (faqApp.vars.brand == 'jlc-ee' && faqApp.vars.language == 'ru') || (faqApp.vars.brand == 'jlc-ee' && faqApp.vars.language == 'en') || (faqApp.vars.brand == 'bet-dk') || (faqApp.vars.brand == 'bet-cba') || (faqApp.vars.brand == 'bet' && faqApp.vars.language == "pe") || (faqApp.vars.brand == 'bsf' && faqApp.vars.language == "en") || (faqApp.vars.brand == 'bsf' && faqApp.vars.language == "ca") || (faqApp.vars.brand == 'nrb' && faqApp.vars.language == "en") || (faqApp.vars.brand == 'lrt' && faqApp.vars.language == "en") || (faqApp.vars.brand == 'spc' && faqApp.vars.language == "en") || (faqApp.vars.brand == 'jkp' && faqApp.vars.language == "en") || (faqApp.vars.brand == 'ceu' && faqApp.vars.language == "en") || (faqApp.vars.brand == 'acb') || (faqApp.vars.brand == 'bth') || (faqApp.vars.brand == 'btd') || (faqApp.vars.brand == 'bet-gr' && faqApp.vars.language == 'en') || (faqApp.vars.brand == 'bsf-pe') || (faqApp.vars.brand == 'nrb-dk') || (faqApp.vars.brand == 'bet-pe') || faqApp.vars.brand == 'crc' || faqApp.vars.brand == 'bet-bbr' || faqApp.vars.brand == 'bet-lt' || faqApp.vars.brand == 'bet-uk'))
                faqApp.cmb.permit = true;
        }
        if ((faqApp.vars.brand == 'bet-es' && faqApp.vars.language == 'es') || (faqApp.vars.brand == 'rzk-es' && faqApp.vars.language == 'es') || (faqApp.vars.brand == 'bet-br' && faqApp.vars.language == 'pt-br')) {
            faqApp.cmb.permit = true;
        }

        //check if live chat form is permitted
        if ((faqApp.vars.brand == 'loc') || (faqApp.vars.brand == 'ahs')) {
            faqApp.lc.permit = false;
        }

        var waitForEl = function(selector, callback) {
            if (jQuery(selector).length) {
                callback();
            } else {
                setTimeout(function() {
                    waitForEl(selector, callback);
                }, 100);
            }
        };

        if (faqApp.vars.language == 'de') {
            waitForEl('#faq_category_id_50', function() {
                const value = `; ${document.cookie}`;
                const parts = value.split(`; gamewebauth=`);
                console.log(value);
                if (parts == null) {
                    document.getElementById("faq_category_id_50").style.display = "none";
                } else {
                    document.getElementById("faq_category_id_50").style.display = "none";
                }
            });
        }
        // Devbrand new chat form on load javacript logic
        if (faqApp.vars.brand == 'dvb' || (faqApp.vars.brand == 'bsf' && faqApp.vars.language == 'cstech')) {
            if(window.innerWidth > 991) { // Desktop devices only
                window.addEventListener("load", function () {

                    let iframe = document.getElementById('chatFormFrame');
                    // iframe.addEventListener("load", function() {
                    let insideDoc = iframe.contentWindow;
                    let innerDoc = insideDoc.document || insideDoc.contentWindow.document;

                    innerDoc.getElementById("preChatForm").onsubmit = function (event) {
                        event.preventDefault();

                        let email = innerDoc.getElementById("email").value;

                        $.ajax({
                            type: 'POST',
                            url: faqApp.vars.host + '/get_vip_status.php',
                            global: false,
                            method: 'POST',
                            data: {email: email}
                        })
                            .done(function (data) {
                                // Store the isVIP variable as a boolean
                                const isVIP = data;
                                console.log('Is VIP:', isVIP);
                                // Call the resolve function to return the isVIP value
                                // resolve(isVIP);
                                return isVIP;
                            })
                            .fail(function (xhr, textStatus, error) {
                                console.error(error);
                                // Call the reject function to indicate an error occurred
                                reject("Error fetching VIP status");
                            })
                            .then(function (isVIP) {
                                if (isVIP) {
                                    window.goToChat(innerDoc);
                                } else {
                                    window.rerouteAda(innerDoc);
                                }
                            })
                            .catch(function (error) {
                                console.error(error);
                                // If there is an error, set isVIP to false and continue
                            });
                    }
                });
                let faqChatHeader = document.getElementById("faq_header_chat");
                let focused = false;

                function isFocused(event) {
                    if (event.data === 'iframeFocused') {
                        console.log("focus");
                        focused = true;
                        faqChatHeader.classList.remove("notification");
                    } else {
                        console.log("no focus");
                        focused = false;
                    }
                }

                window.addEventListener('message', isFocused, false);

                faqChatHeader.addEventListener('click', function () {
                    console.log("faqChatHeader clicked");
                    faqChatHeader.classList.remove("notification");
                });

                window.addEventListener('message', function (event) {
                    if (event.data === 'newMessage' && !focused) {
                        console.log('The sound was played in the iframe! and not focused, showing notification');
                        faqChatHeader.classList.add("notification");
                    }
                });
            }
        }
    });

    if ($('#faq_totop')) {
        faqApp.func.totop();
    }
    searchRequestLock = false;

    if(faqApp.vars.brand == 'dvb' || faqApp.vars.brand == 'jko' || faqApp.vars.brand == 'rcb' || faqApp.vars.brand == 'rcb-de' || faqApp.vars.brand == 'bet' || faqApp.vars.brand == 'bet-ar' || faqApp.vars.brand == 'bet-gr' || faqApp.vars.brand == 'bet-nl' || faqApp.vars.brand == 'bet-arp' || faqApp.vars.brand == 'ahs' || faqApp.vars.brand == 'bsf' || faqApp.vars.brand == 'bsf-lv' || faqApp.vars.brand == 'bsf-ee' || faqApp.vars.brand == 'csn-dk' || faqApp.vars.brand == 'ceu' ||
        faqApp.vars.brand == 'nrb' || faqApp.vars.brand == 'nrb-dk' || faqApp.vars.brand == 'bet-mx' || faqApp.vars.brand == 'rzk' || faqApp.vars.brand == 'rzk-hr' || faqApp.vars.brand == 'gts' || faqApp.vars.brand == 'orj' || faqApp.vars.brand == 'rzk-rs' || faqApp.vars.brand == 'jkp' || faqApp.vars.brand == 'lrt' || faqApp.vars.brand == 'spc' || faqApp.vars.brand == 'stc' || faqApp.vars.brand == 'bet-dk' || faqApp.vars.brand == 'bet-cba' || faqApp.vars.brand == 'bet-pe' ||
        faqApp.vars.brand == 'bsf-pe' || faqApp.vars.brand == 'acb' || faqApp.vars.brand == 'bth' || faqApp.vars.brand == 'btd' || faqApp.vars.brand == 'jlc' || faqApp.vars.brand == 'bet-uk' || faqApp.vars.brand == 'bet-py' ||
        faqApp.vars.brand == 'bet-bbr' || faqApp.vars.brand == 'bet-it')
    {
        faqApp.oneTrust.permit = true;
    }
};


faqApp.func.faqUri = function(id) {
    var faq_v_href = "";
    if (faqApp.obj.uri.uri && faqApp.obj.uri.faquri) {
        if (faqApp.obj.uri.faqurl) {
            faq_v_href = 'href="' + faqApp.obj.uri.faqurl + '?' + faqApp.obj.uri.faquri + '=' + id + '" ';
        } else {
            faq_v_href = 'href="?' + faqApp.obj.uri.faquri + '=' + id + '" ';
        }

    }
    return faq_v_href;
};
faqApp.func.categoryUri = function(id) {
    var faq_v_href = "";
    if (faqApp.obj.uri.uri === true && faqApp.obj.uri.categoryuri) {
        if (faqApp.obj.uri.categoryurl) {
            faq_v_href = 'href="' + faqApp.obj.uri.categoryurl + '?' + faqApp.obj.uri.categoryuri + '=' + id + '" ';
        } else {
            faq_v_href = 'href="?' + faqApp.obj.uri.categoryuri + '=' + id + '" ';
        }

    }
    return faq_v_href;
};
faqApp.func.searchUri = function(data) {
    var faq_v_href = "";
    if (faqApp.obj.uri.uri === true && faqApp.obj.uri.searchuri) {
        if (faqApp.obj.uri.searchurl) {
            faq_v_href = faqApp.obj.uri.searchurl + '?' + faqApp.obj.uri.searchuri + '=' + encodeURI(data);
        } else {
            faq_v_href = '?' + faqApp.obj.uri.searchuri + '=' + encodeURI(data);
        }

    }
    return faq_v_href;
};
faqApp.func.ajax = function(action, sendData, loadingSwitch, callback) {
    $.ajax({
        type: "POST",
        timeout: 10000,
        url: faqApp.vars.host + action + "&lang=" + faqApp.vars.language,
        data: sendData,
        global: loadingSwitch,
        success: function(response) {
            if (response) {
                var data;
                if (typeof response !== "object") {
                    data = JSON.parse(response);
                } else {
                    data = response;
                }
                if (data.length < 1) {
                    faqApp.vars.lastfaq = 0;
                    faqApp.vars.lastcat = 0;
                    $('#faq_app_renderbox').html('<div class="faq_body_alert"><i class="fa fa-exclamation-triangle"></i> ' + faqApp.obj[503][faqApp.vars.language] + '</div>');
                }
                if (callback) callback(data);
            }
        },
        error: function(error, textmessage) {
            if ($('#ajaxProgressBar')) {
                $('#ajaxProgressBar').removeClass('progress-bar-info').addClass('progress-bar-danger');
                $('#progress--header').html('<i class="fa fa-exclamation-triangle"></i> ' + faqApp.obj[404][faqApp.vars.language]);
            } else {
                faqApp.vars.lastfaq = 0;
                faqApp.vars.lastcat = 0;
                $('#faq_app_renderbox').html('<div class="faq_body_alert"><i class="fa fa-exclamation-triangle"></i> ' + faqApp.obj[503][faqApp.vars.language] + '</div>');
            }
        }
    });
};
// when an ajax request is sent, sp-circle will be displayed until a response is received
$('#faq_app_renderbox').ready(function() {
    $(document).ajaxStart(function() {
        faqApp.func.scroll();
        $('#faq_app_renderbox').hide();
        $('#faq_app_renderbox').html('<div class="sp sp-circle"></div>').show();
    }).ajaxStop(function() {
        $('#faq_app_renderbox').show();
        $('.sp-circle').hide();
    });
});

faqApp.func.grabElement = function(d) {
    return document.getElementById(d);
};

faqApp.func.addElement = function(a, b, c, d, e) {
    var element = document.createElement(a);
    var element_id = document.createAttribute('id');
    var element_class = document.createAttribute('class');
    element_id.value = b;
    element_class.value = c;
    element.setAttributeNode(element_id);
    element.setAttributeNode(element_class);
    faqApp.func.grabElement(d).appendChild(element);
    if (e) {
        e();
    }
};
faqApp.func.vote = function(e, recordId) {
    voteValue = faqApp.func.getId(e.id);
    recordTitle = $('.faq--record h2').text();
    faqApp.func.ajax("/ajaxservice.php?action=savevoting", 'type=faq&vote=' + voteValue + '&id=' + recordId + '&lang=' + faqApp.vars.language, false, function(data) {
        if (data.success) {
            faqApp.func.grabElement('faq_footer_id').innerHTML = '<span class="faq--response"><br />' + data.success + '</span>';
        } else {
            faqApp.func.grabElement('faq_footer_id').innerHTML = '<span class="faq--response"><br />' + data.error + '</span>';
        }
    });

    // GAM - vote
    if (voteValue == 5) {
        voteValue = 'Yes';
    } else {
        voteValue = 'No';
    }
    pushDatalayer(3, null, null, recordId, recordTitle, null, null, voteValue);
};
faqApp.func.search = function(e) {
    // make current active category inactive when keyword searched
    $('#' + faqApp.vars.active).removeClass('faq_nav_active').addClass('faq_nav_inactive');
    faqApp.vars.active = null;
    var searchResults = 0;
    if (e.keyCode === 13 || e.type == 'click' || e.faqsearch) {
        if (!searchRequestLock) {
            // faqApp.func.enableSearchRequestLock(); // enable grey background on search box, disables & locks it
            var faqSearchString = faqApp.func.grabElement('faq_textinput_id').value;
            faqSearchString = DOMPurify.sanitize(faqSearchString);
            if (faqSearchString && faqApp.obj.uri.searchuri) {
                window.open(faqApp.func.searchUri(faqSearchString), '_self');
            } else if (e.faqsearch) {
                faqSearchString = e.faqsearch;
            }
            if ((!faqApp.obj.uri.searchuri && !faqApp.obj.uri.searchurl) || e.faqsearch) {
                quotedSearchString = "'" + faqSearchString.trim() + "'";
                url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=search&q=';
                faqApp.func.ajax(url + encodeURI(quotedSearchString).slice(0, 100), null, true, function(data) {
                    faqApp.vars.lastfaq = 0;
                    faqApp.vars.lastcat = 0;
                    //render result
                    if (data.length > 0) {
                        found = true;
                        searchResults = data.length;
                        // run render function w/ number of found searchResults as parameter
                        faqApp.func.render(true, data, 1, searchResults, faqSearchString, true);
                        var searchPhrase = faqSearchString.trim().split(" ");
                        faqApp.func.highlightWordsinDom(faqApp.func.grabElement('faq_app_renderbox'), searchPhrase);
                    } else if (data.length === 0) {
                        // run render function w/ 0 found searchResults as parameter
                        faqApp.func.render(true, data, 1, 0, faqSearchString, true);
                        faqApp.func.grabElement('faq_app_renderbox').innerHTML = '<div class="faq--resulttree zero--results">' + faqApp.obj.translation.search_zeroresult + '<p class="zero--results-string">"' + faqSearchString.trim() + '"</p></div>';
                    } else {
                        faqApp.func.grabElement('faq_app_renderbox').innerHTML = '<div class="faq--resulttree zero--results">' + faqApp.obj.translation.search_zeroresult + '<p class="zero--results-string">"' + faqSearchString.trim() + '"</p></div>';
                    }
                    faqApp.func.disableSearchRequestLock();
                    faqApp.func.scroll();
                    searchRequestLock = false;
                });
            } else {
                window.open(faqApp.func.searchUri(faqSearchString), '_self');
            }
        }
    }
};

faqApp.func.enableSearchRequestLock = function() {
    searchRequestLock = true;
    // disable submit and textfield
    $('.faq--searchinput').prop('disabled', true);
    $('.faq--searchbutton').prop('disabled', true);
    // darken background color
    $('.faq--searchinput').css("background-color", "#bbbbbb");
    $('.faq--searchbutton').css("background-color", "#bbbbbb");
    return searchRequestLock;
};
faqApp.func.disableSearchRequestLock = function() {
    searchRequestLock = false;
    $('.faq--searchinput').prop('disabled', false);
    $('.faq--searchbutton').prop('disabled', false);
    $('.faq--searchinput').removeAttr('style');
    $('.faq--searchbutton').removeAttr('style');
    return searchRequestLock;
};

faqApp.func.render = function(render, data, type, searchResults, faqSearchString, searchMade) {
    if ($('#navigation-panel') && $('#navigation-panel').hasClass('mb_panel_show')) {
        faqApp.func.hamburger();
    }
    faqApp.obj.events.history = {
        data: data,
        type: type
    };
    // Cache Bust 1
    if (render && faqApp.vars.language != 'gr') {
        faqApp.func.grabElement('faq_app_renderbox').innerHTML = "";
        $.each(data, function(k, e) {
            if (e.category_name && !faqApp.func.grabElement('faq--cathead-' + e.category_id)) {
                faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.grabElement('faq_app_renderbox').innerHTML + '<h1 id="faq--cathead-' + e.category_id + '">' + e.category_name + '<a href="#site" class="faq_home_btn"><i class="fa fa-arrow-circle-o-up fa-sm pull-right"></i></a></h1>';
            }
            faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.grabElement('faq_app_renderbox').innerHTML + faqApp.func.resultTree(e, type);
        });
    } else if (render && faqApp.vars.language == 'gr') {
        faqApp.func.grabElement('faq_app_renderbox').innerHTML = "";
        $.each(data, function(k, e) {
            if (e.category_name && !faqApp.func.grabElement('faq--cathead-' + e.category_id)) {
                faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.grabElement('faq_app_renderbox').innerHTML + '<h1 lang="el" id="faq--cathead-' + e.category_id + '">' + e.category_name + '<a href="#site" class="faq_home_btn"><i class="fa fa-arrow-circle-o-up fa-sm pull-right"></i></a></h1>';
            }
            faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.grabElement('faq_app_renderbox').innerHTML + faqApp.func.resultTree(e, type);
        });
    }
    if ((searchResults != 0) && (!searchMade)) {
        // #76 - Checks whether active category matches actual rendered content title
        categ = 'faq_category_id_' + faqApp.obj.events.history.data[0].category_id;
        if (faqApp.vars.active != categ) {
            faqApp.func.navigation(categ, true);
        }
    }
    faqApp.func.scroll();
    if (faqApp.vars.init === 0) {
        progressLoader(10);
        faqApp.vars.init = 1;
    }
    // GAM - search
    if (searchMade) {
        faqApp.vars.onSearchPage = true;
        pushDatalayer(2, null, "Search Results", null, null, faqSearchString, searchResults, null);
    }
};
faqApp.func.resultTree = function(data, type) {
    var datablock = "";
    switch (type) {
        case 1:
            datablock = '<section class="faq--resulttree"><h2><a role="button" ' + faqApp.func.faqUri(data.id) + '  id="faq_result_id_' + data.id + '" faq-data="ajax-faq">' + data.question + '</a><a href="#site" class="faq_home_btn"><i class="fa fa-arrow-circle-o-up fa-sm pull-right"></i></a></h2><p>' + data.answer + '</p></section>';
            break;
        case 2:
            var answerPreview = data.record_preview.trim() + "..." + (faqApp.obj.translation.read_more_lbl ? ` <a role="button" id="faq_preview_link_id_${data.record_id}">${faqApp.obj.translation.read_more_lbl}</a>` : "");
            datablock = '<section class="faq--resulttree"><h2><a role="button" ' + faqApp.func.faqUri(data.record_id) + '  id="faq_result_id_' + data.record_id + '" faq-data="ajax-faq">' + data.record_title + '</a></h2><p>' + answerPreview + '</p></section>';
            break;
    }
    return datablock;
};

faqApp.func.highlightWordsinDom = function(root, wordArray) {
    for (var i = 0; i < wordArray.length; i++) {
        if (wordArray[i].length > 3) {
            faqApp.func.highlightWordInDom(root, wordArray[i]);
        }
    }
};

faqApp.func.highlightWordInDom = function(root, word) {
    textNodesUnder(root).forEach(highlightWords);

    function textNodesUnder(root) {
        var walk = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false),
            text = [],
            node;
        while (node = walk.nextNode()) text.push(node);
        return text;
    }
    //Highlight search function
    function highlightWords(n) {
        word = word.toLowerCase();
        var after;
        for (var i;
            (i = n.nodeValue.toLowerCase().indexOf(word, i)) > -1; n = after) {
            after = n.splitText(i + word.length);
            var highlighted = n.splitText(i);
            var span = document.createElement('span');
            span.className = 'faq--highlight';
            span.appendChild(highlighted);
            after.parentNode.insertBefore(span, after);
        }
    }
};

faqApp.func.getId = function(data) {
    if (data !== parseInt(data, 10)) {
        data = data.replace(/[^\-\d]*(\-?\d*).*/, '$1');
    }
    return data;
};

faqApp.func.openFaq = function(e, quickLinkClicked) {
    if (quickLinkClicked) {
        categoryName = 'Quick Link';
        recordId = $(e).parent().attr('id');
        recordName = e.innerHTML;
    } else {
        categoryName = faqApp.func.getCategoryName();
        recordId = faqApp.func.getId(e.id);
        recordName = e.text;
    }
    if ($('#navigation-panel') && $('#navigation-panel').hasClass('mb_panel_show')) {
        faqApp.func.hamburger();
    }
    if (typeof faqApp.vars.lastfaq === "number" && faqApp.vars.lastfaq != parseInt(recordId)) {
        faqApp.vars.lastfaq = parseInt(recordId);
        faqApp.vars.lastcat = 0;
        if (faqApp.func.grabElement('faq_result_id_' + recordId)) {
            faqApp.func.grabElement('faq_result_id_' + recordId).innerHTML = faqApp.func.grabElement('faq_result_id_' + recordId).innerHTML + '<div class="faq--ajaxspinner"></div>';
        }
        if ((!faqApp.obj.uri.faquri && !faqApp.obj.uri.faqurl) || faqApp.obj.uri[faqApp.obj.uri.faquri]) {
            url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getFaq&recordId=';
            if (quickLinkClicked) {
                categoryUrl = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getQuickLinkCategory&recordId=';
                faqApp.func.ajax(categoryUrl + recordId, null, true, function(data) {
                    if (data.length > 0) {
                        faqApp.func.render(false, data, 2);
                    }
                    faqApp.func.loadFaq(url, recordId);
                });
            } else {
                faqApp.func.loadFaq(url, recordId);
            }
        }
    }
    // GAM - record
    pushDatalayer(1, null, categoryName, recordId, recordName, null, null, null);

};

faqApp.func.loadFaq = function(url, recordId) {
    faqApp.func.ajax(url + recordId, null, true, function(data) {
        faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.resultFaq(data);

        //Declaration of search words array
        var searchPhrase = faqApp.func.grabElement('faq_textinput_id').value.trim().split(" ");
        searchPhrase = DOMPurify.sanitize(searchPhrase);
        searchPhrase = searchPhrase.split(",");
        if (searchPhrase.length > 0) {
            faqApp.func.highlightWordsinDom(faqApp.func.grabElement('faq_app_renderbox'), searchPhrase);
        }
        faqApp.func.scroll();
        if ($('#launchsaform').length > 0) {
            if (typeof faqApp.func.loadSaForm === 'function') {
                faqApp.func.loadSaForm();
            }
        }
        //Deposit Options
        if ($('#launchdpopts').length > 0) {
            if (typeof faqApp.func.loadDpOpts === 'function') {
                faqApp.func.loadDpOpts();
            }
        }
        //Withdrawal Options
        if ($('#launchwdopts').length > 0) {
            if (typeof faqApp.func.loadWdOpts === 'function') {
                faqApp.func.loadWdOpts();
            }
        }
        //Complaint Form
        if ($('#launchcomplaintform').length > 0) {
            if (typeof faqApp.func.loadComplaintForm === 'function') {
                faqApp.func.loadComplaintForm();
            }
        }
    });
};

faqApp.func.keywordSearch = function(e) {
    faqApp.vars.lastfaq = 0;
    faqApp.vars.lastcat = 0;
    var faqSearchString = faqApp.func.grabElement('faq_textinput_id').value;
    faqSearchString = DOMPurify.sanitize(faqSearchString);
    quotedSearchString = "'" + faqSearchString.trim() + "'";
    url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=search&q=';
    faqApp.func.ajax(url + quotedSearchString, null, true, function(data) {
        if (data.length > 0)
            faqApp.func.render(true, data, 1);
    });
};
faqApp.func.faqsPerCategory = function(e) {
    if (typeof faqApp.vars.lastcat === "number" && faqApp.vars.lastcat != parseInt(faqApp.func.getId(e))) {
        faqApp.vars.lastcat = parseInt(faqApp.func.getId(e));
        faqApp.vars.lastfaq = 0;
        if ((!faqApp.obj.uri.categoryuri && !faqApp.obj.uri.categoryurl) || faqApp.obj.uri[faqApp.obj.uri.categoryuri]) {
            url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getFaqs&categoryId=';
            faqApp.func.ajax(url + faqApp.func.getId(e), null, true, function(data) {
                if (data.length > 0)
                    faqApp.func.render(true, data, 2);
            });
        }
    }
    // GAM - category
    pushDatalayer(0, faqApp.func.getId(e), faqApp.func.getCategoryName(), null, null, null, null, null);
};

faqApp.func.getCategoryName = function() {
    return $('.faq_nav_active').text();
};

faqApp.func.resultFaq = function(data) {
    var keywordNode = "",
        backbutton = "";
    if (data.keywords.length > 0) {
        var keywords = data.keywords.split(",");
        $.each(keywords, function(k, d) {
            keywordNode = keywordNode + '<a role="button" id="' + d + '" faq-data="ajax-keyword">' + d + '</a>';
        });
        keywordNode = '<div class="faq--keywords" id="faq_keywords_id">Keywords ' + keywordNode + '</div>';
    }
    if (faqApp.obj.events.history && faqApp.obj.events.history.data[0] && faqApp.obj.events.history.data[0].category_name && faqApp.vars.language != 'gr') {
        backbutton = '<h1><a role="button" id="faq_history_id" faq-data="object-history" class="faq--backbtn"><i class="fa fa-chevron-left"></i>' + faqApp.obj.events.history.data[0].category_name + '</a></h1>';
    } else if (faqApp.obj.events.history && faqApp.obj.events.history.data[0] && faqApp.obj.events.history.data[0].category_name && faqApp.vars.language == 'gr') {
        backbutton = '<h1 lang="el"><a role="button" id="faq_history_id" faq-data="object-history" class="faq--backbtn"><i class="fa fa-chevron-left"></i>' + faqApp.obj.events.history.data[0].category_name + '</a></h1>';
    } else if ($('#faq_textinput_id').val().length > 0 && faqApp.vars.language != 'gr') {
        backbutton = '<h1><a role="button" id="faq_history_id" faq-data="object-history" class="faq--backbtn"><i class="fa fa-chevron-left"></i>' + faqApp.obj.translation.back_to_search_button_lbl + ' ' + $('#faq_textinput_id').val() + '</a></h1>';
        faqApp.vars.onSearchPage = true;
    }
    else if ($('#faq_textinput_id').val().length > 0 && faqApp.vars.language == 'gr') {
        backbutton = '<h1 lang="el"><a role="button" id="faq_history_id" faq-data="object-history" class="faq--backbtn"><i class="fa fa-chevron-left"></i>' + faqApp.obj.translation.back_to_search_button_lbl + ' ' + $('#faq_textinput_id').val() + '</a></h1>';
        faqApp.vars.onSearchPage = true;
    }
    if ((faqApp.vars.active == "faq_nav_topten")) {
        backbutton = '<h1><a role="button" id="faq_nav_topten" faq-data="object-topten" class="faq--backbtn"><i class="fa fa-chevron-left"></i>' + faqApp.obj.translation.topten_faq_lbl + '</a></h1>';
    }
    if (data.active == "yes") {
        ratingBlock = '<span id="faq--rating-header">' + faqApp.obj.translation.rating_ratethis_lbl + '</span><div class="faq--rating" id="faq_rating_id"><div role="button" id="faq_id_vote_5" faq-data="ajax-vote" faq-value="' + data.id + '"><i class="fa fa-check"></i> ' + faqApp.obj.translation.rating_btn_yes_lbl + '</div><div role="button" id="faq_id_vote_1" faq-data="ajax-vote" faq-value="' + data.id + '"><i class="fa fa-times"></i> ' + faqApp.obj.translation.rating_btn_no_lbl + '</div></div>';
    } else {
        ratingBlock = "";
    }
    var datablock = backbutton + '<section class="faq--record"><h2>' + data.title + '</h2>' + data.content + keywordNode + '<div class="faq--footer" id="faq_footer_id">' + ratingBlock + '</div></section>';
    return datablock;
};
faqApp.func.pageRender = function(faq_categories, faq_topten, faq_info) {
    if (!faqApp.func.grabElement('faq_app_renderbox')) {
        // console.log('Application needs an element (e.g DIV) with id="faq_app_renderbox" to function.');
    } else if (!faqApp.func.grabElement('faq_app_searchbox')) {
        // console.log('Application needs an element (e.g DIV) with id"faq_app_searchbox" to function');
    } else {
        if (faq_info) {
            if (faq_info.info_contactinfomsg && faq_info.info_contactinfomsg.length > 2) {
                if($('#contact-info-message')) {
                    const isMobile = window.innerWidth < 1025;
                    if (isMobile) { // Move info message to above contact buttons
                        $('#contact-info-message')[0].parentElement.insertBefore($('#contact-info-message')[0], $('#contact-info-message')[0].parentElement.firstChild);
                    }
                    $('#contact-info-message').html(faq_info.info_contactinfomsg).removeClass('element-hidden');
                }
            }
            if (faq_info.info_alertmsg && faq_info.info_alertmsg.length > 2) {
                if ($('#panel-alert')) {
                    $('#panel-alert').html(faq_info.info_alertmsg).removeClass('element-hidden').addClass('element-show');
                    if((faqApp.vars.brand == 'dvb') || (faqApp.vars.brand == 'bsf' && faqApp.vars.language == 'cstech')) {
                        if(window.innerWidth > 991){ // Desktop devices only
                            const iframe = document.getElementById('chatFormFrame');
                            iframe.addEventListener('load', function() {
                                if ($('#panel-alert-form')) {
                                    const insideDoc = iframe.contentWindow;
                                    const innerDoc = insideDoc.document || insideDoc.contentWindow.document;
                                    $('#panel-alert-form').html(faq_info.info_alertmsg).removeClass('element-hidden').addClass('element-show');
                                    let alertBox = innerDoc.getElementById("panel-alert-form");
                                    $(alertBox).html(faq_info.info_alertmsg).removeClass('element-hidden').addClass('element-show');
                                }
                            });
                        }
                    }
                }
            }
            // promo banner
            if (faq_info.info_promotionmsg && faq_info.info_promotionmsg.length > 2) {
                if ($('#panel-promotion')) {
                    $('#panel-promotion').html(faq_info.info_promotionmsg).removeClass('element-hidden').addClass('element-show');
                }
            }
            //
            if (faq_info.info_infomsg && faqApp.func.grabElement('faq--panel')) {
                faqApp.func.addElement('div', 'faq_staticbox', null, 'faq--panel', function(callback) {
                    faqApp.func.grabElement('faq_staticbox').innerHTML = faq_info.info_infomsg;
                });
            }
            // betsafe baltlics EN & RU do not have phone numbers
            if (!faq_info.info_phonenumber) {
                $('#faq_header_chat').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_email').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_whatsapp').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_phone').remove();
            }

            if ((!faq_info.info_phonenumber) && (!faq_info.info_chaturl)) {
                $('#faq_header_email').removeClass().addClass("col-xs-13 col-sm col-md-13 col-lg-13");
                $('#faq_header_phone').remove();
                $('#faq_header_chat').remove();
            }

            // Whatsapp
            if (!faq_info.info_whatsapp) {
                $('#faq_header_chat').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_email').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_phone').removeClass().addClass("col-xs-4 col-sm-4 col-md-4 col-lg-4");
                $('#faq_header_whatsapp').remove();
            }

            if ((!faq_info.info_phonenumber) && (!faq_info.info_whatsapp)) {
                $('#faq_header_chat').removeClass().addClass("col-xs-6 col-sm col-md-6 col-lg-6");
                $('#faq_header_email').removeClass().addClass("col-xs-6 col-sm col-md-6 col-lg-6");
                $('#faq_header_phone').remove();
                $('#faq_header_whatsapp').remove();
            }

            if (faq_info.info_emailaddress || faq_info.info_phonenumber || faq_info.info_chaturl || faq_info.info_whatsapp) {
                // var printURL = '';
                if (faq_info.info_emailaddress) {
                    // printURL = (faqApp.vars.email_link) ? faqApp.vars.email_link : faq_info.info_emailaddress;
                    let emailTooltipContent = faq_info.info_emailaddress;
                    switch (faqApp.vars.brand) {
                        case 'bet-ar':
                            emailTooltipContent = 'Utilice la dirección de correo electrónico asociada a su cuenta de BETSSON para una ayuda mas rapida';
                            break;
                        case 'bet-arp':
                            emailTooltipContent = 'Utilice la dirección de correo electrónico asociada a su cuenta de BETSSON para una ayuda mas rapida';
                            break;
                        case 'bet-cba':
                            emailTooltipContent = 'Utilice la dirección de correo electrónico asociada a su cuenta de BETSSON para una ayuda mas rapida';
                            break;
                    }
                    if (faqApp.vars.brand != 'jlc') {
                        faqApp.func.addElement('div', 'faq_info_email', 'faq_info_complete', 'faq_header_email', function() {
                            if((faqApp.vars.language == 'pe') || (faqApp.vars.language == 'cl') || (faqApp.vars.brand == 'bet' && faqApp.vars.language == 'pt-br') || (faqApp.vars.brand == 'bet-ar') || (faqApp.vars.brand == 'bet-arp') || (faqApp.vars.brand == 'bet-cba') || (faqApp.vars.brand == 'bet-mx')){
                                faqApp.func.grabElement('faq_info_email').innerHTML = '<section><a class="btn btn-lg btn-primary btn-block" href="mailto:' + faq_info.info_emailaddress + '" data-toggle="tooltip" data-placement="top" title="' + emailTooltipContent + '" id="faq_toggle_email"><div class="faq_button_icon"><i class="fa fa-at fa-lg pull-left"></i></div><div class="faq_button_content">' + faqApp.obj.translation.info_email_lbl.replace(/(\[email\])/g, "<b>" + faq_info.info_emailaddress + "</b>") + '<p>' + faq_info.info_emailsla + '</p></div></a></section>';
                            }
                            else{
                                faqApp.func.grabElement('faq_info_email').innerHTML = '<section><a class="btn btn-lg btn-primary btn-block" href="mailto:' + faq_info.info_emailaddress + '" data-toggle="tooltip" data-placement="top" title="' + faq_info.info_emailaddress + '" id="faq_toggle_email"><div class="faq_button_icon"><i class="fa fa-at fa-lg pull-left"></i></div><div class="faq_button_content">' + faqApp.obj.translation.info_email_lbl.replace(/(\[email\])/g,'') + '<p>' + faq_info.info_emailsla + '</p></div></a></section>';
                            }
                        });
                    } else {
                        faqApp.func.addElement('div', 'faq_info_email', 'faq_info_complete', 'faq_header_email', function() {
                            faqApp.func.grabElement('faq_info_email').innerHTML = '<section><a class="btn btn-lg btn-primary btn-block" data-toggle="tooltip" data-placement="top" title="' + faq_info.info_emailaddress + '" id="faq_toggle_email"><div class="faq_button_icon"><i class="fa fa-at fa-lg pull-left"></i></div><div class="faq_button_content">' + faqApp.obj.translation.info_email_lbl + '<p>' + faq_info.info_emailsla + '</p></div></a></section>';
                        });
                    }
                    $('[data-toggle="tooltip"]').tooltip();
                }
                if (faq_info.info_phonenumber) {
                    faqApp.func.addElement('div', 'faq_info_phone', 'faq_info_complete', 'faq_header_phone', function() {
                        if (faqApp.cmb.permit) { // for CMB enabled brands / languages only
                            faqApp.func.grabElement('faq_info_phone').innerHTML = '<section><a class="btn btn-lg btn-link btn-block"><div class="faq_button_icon"><i class="fa fa-phone fa-lg pull-left" alt="' + faqApp.obj.translation.info_phone_lbl + '"></i></div><div class="faq_button_content"><span id="faq_phone_number" >' + faqApp.obj.translation.callmeback_lbl + '</span><div id="faq_phone_call"><span>' + faqApp.obj.translation.callmeback_lbl + '</span></div><p>' + faq_info.info_phonesla + '</p></div></a></section>';
                            document.getElementById('cmb_note').innerHTML = '<span style="display: block;font-size: 12px;font-style: italic;">' + faqApp.obj.translation.cmb_note_message + '</span>';
                        } else {
                            if (faqApp.vars.brand == 'bet-kz') {
                                faqApp.func.grabElement('faq_info_phone').innerHTML = '<section><a class="btn btn-lg btn-link btn-block" href="tel:' + faq_info.info_phonenumber + '"><div class="faq_button_icon"><i class="fa fa-phone fa-lg pull-left" alt="' + faqApp.obj.translation.info_phone_lbl + '"></i></div><div class="faq_button_content"><span id="faq_phone_number" >' + faq_info.info_phonenumber + '</span><span id="faq_phone_call" >' + faq_info.info_phonenumber + '</span><p>' + faq_info.info_phonesla + '</p></div></a></section>';
                            } else {
                                faqApp.func.grabElement('faq_info_phone').innerHTML = '<section><a class="btn btn-lg btn-link btn-block" href="tel:' + faq_info.info_phonenumber + '"><div class="faq_button_icon"><i class="fa fa-phone fa-lg pull-left" alt="' + faqApp.obj.translation.info_phone_lbl + '"></i></div><div class="faq_button_content"><span id="faq_phone_number" >' + faq_info.info_phonenumber + '</span><span id="faq_phone_call" >' + faqApp.obj.translation.info_phone_lbl + '</span><p>' + faq_info.info_phonesla + '</p></div></a></section>';
                            }
                        }
                    });
                }
                if (faq_info.info_chaturl) { //new chat form test 3
                    faqApp.func.addElement('div', 'faq_info_chat', 'faq_info_complete', 'faq_header_chat', function() {
                        // New Chat Form
                            if ((faqApp.vars.brand == 'dvb') || (faqApp.vars.brand == 'rcb-dev') || (faqApp.vars.brand == 'bsf' && faqApp.vars.language == 'cstech'))
                            {
                                if(window.innerWidth > 991) { // Desktop devices only
                                    faqApp.func.grabElement('faq_info_chat').innerHTML = `<section><a class="btn btn-lg btn-primary btn-block" href="#"><div class="faq_button_icon"><i class="fa fa-comments-o fa-lg pull-left"></i></div><div class="faq_button_content">${faqApp.obj.translation.info_chat_lbl}<p>${faq_info.info_chatsla}</p></div></a></section>`;
                                }
                                // Legacy Chat Form
                                else{
                                    faqApp.func.grabElement('faq_info_chat').innerHTML = `<section><a class="btn btn-lg btn-primary btn-block" href="#" onClick="window.open('${faq_info.info_chaturl}', 'ChatWindow', 'height=${faq_info.livechat_window.window_height},width=${faq_info.livechat_window.window_width},resizable=yes,scrollbars=yes');void(0);"><div class="faq_button_icon"><i class="fa fa-comments-o fa-lg pull-left"></i></div><div class="faq_button_content">${faqApp.obj.translation.info_chat_lbl}<p>${faq_info.info_chatsla}</p></div></a></section>`;
                                }
                            }
                        // Legacy Chat Form STC Variable
                        else{
                            if(faqApp.vars.brand == 'stc') {
                                var referralURL = document.referrer;
                                var isObga = referralURL.includes("www2");
                                var param = "";
                                if (isObga) {
                                    // Set a variable or cookie to "new"
                                    param = "site=obga";
                                } else {
                                    // Set a variable or cookie to "old"
                                    param = "site=legacy";
                                }
                                faq_info.info_chaturl += "?" + param;
                                faqApp.func.grabElement('faq_info_chat').innerHTML = `<section><a class="btn btn-lg btn-primary btn-block" href="#" onClick="window.open('${faq_info.info_chaturl}', 'ChatWindow', 'height=${faq_info.livechat_window.window_height},width=${faq_info.livechat_window.window_width},resizable=yes,scrollbars=yes');void(0);"><div class="faq_button_icon"><i class="fa fa-comments-o fa-lg pull-left"></i></div><div class="faq_button_content">${faqApp.obj.translation.info_chat_lbl}<p>${faq_info.info_chatsla}</p></div></a></section>`;
                            }
                            else{
                                // Legacy Chat Form
                                faqApp.func.grabElement('faq_info_chat').innerHTML = `<section><a class="btn btn-lg btn-primary btn-block" href="#" onClick="window.open('${faq_info.info_chaturl}', 'ChatWindow', 'height=${faq_info.livechat_window.window_height},width=${faq_info.livechat_window.window_width},resizable=yes,scrollbars=yes');void(0);"><div class="faq_button_icon"><i class="fa fa-comments-o fa-lg pull-left"></i></div><div class="faq_button_content">${faqApp.obj.translation.info_chat_lbl}<p>${faq_info.info_chatsla}</p></div></a></section>`;
                                }
                        }
                    })
                }
                if (faq_info.info_whatsapp) {
                    faqApp.func.addElement('div', 'faq_info_whatsapp', 'faq_info_complete', 'faq_header_whatsapp', function() {
                        // Whatsapp permitted brands
                        if(faqApp.vars.brand == 'dvb' || faqApp.vars.brand == 'stc' || (faqApp.vars.brand == 'bet' && faqApp.vars.language == 'pe') || faqApp.vars.brand == 'bet-es' || faqApp.vars.brand == 'bet-it' || faqApp.vars.brand == 'bsf-pe')
                        {
                            faqApp.func.grabElement('faq_info_whatsapp').innerHTML = `<section><a class="btn btn-lg btn-primary btn-block" href="#"><div class="faq_button_icon"><i class="fa fa-whatsapp fa-lg pull-left"></i></div><div class="faq_button_content">Whatsapp<p>${faq_info.info_whatsapp}</p></div></a></section>`;
                            if(window.innerWidth > 991){
                                update_info_whatsapp();
                                function update_info_whatsapp(){
                                    isInterfaceOpen().then(function(result) {
                                      if(result)
                                      {
                                          faqApp.func.grabElement('faq_info_whatsapp').innerHTML = `<section><a class="btn btn-lg btn-primary btn-block" href="#"><div class="faq_button_icon"><i class="fa fa-whatsapp fa-lg pull-left"></i></div><div class="faq_button_content">Whatsapp<p>${faq_info.info_whatsapp}</p></div></a></section>`;
                                      }
                                      else{
                                          faqApp.func.grabElement('faq_info_whatsapp').innerHTML = `<section><a class="btn btn-lg btn-primary btn-block" href="#"><div class="faq_button_icon"><i class="fa fa-whatsapp fa-lg pull-left"></i></div><div class="faq_button_content">Whatsapp<p>${faqApp.obj.translation.info_unavailable_text}</p></div></a></section>`;
                                      }
                                    }).catch(function(error) {
                                      console.log("Error");
                                    });
                                }
                                setInterval(update_info_whatsapp, 1 * 60 * 1000);
                            }
                        }
                    });
                }
            }
            if (faq_info.btn_search_suggestion) {
                $('#faq_subsearch_field').html(faq_info.btn_search_suggestion);
            }
            /*if (faq_info.info_headerlogohtml) {
                if ($('#faq_heading_logo')) {
                    faqApp.func.grabElement('faq_heading_logo').innerHTML = faq_info.info_headerlogohtml;
                }
            }*/
            if (faq_info.info_footerhtml) {
                faqApp.func.grabElement('faq_div_footer').innerHTML = faq_info.info_footerhtml;
            }
            if (faq_info.info_openinghours) {
                faqApp.func.grabElement('faq_howhelp').innerHTML = '<p>' + faq_info.info_openinghours + '</p>';
            }
            // Test push virtual page view event and virtualurl while on main site
            pushDatalayer(6, null, null, null, null, null, null, null);
        }
        if (faqApp.func.grabElement('faq_app_categorybox')) {
            // category header
            faqApp.func.grabElement('faq_app_categorybox').innerHTML = '<h1>' + faqApp.obj.translation.categories_header_lbl + '</h1>';
            //  most_popular_faqs button
            faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + '<a role="button" faq-data="object-topten" id="faq_nav_topten" class="faq_nav_active"><li>' + faqApp.obj.translation.topten_faq_lbl + '</li></a>';
            // for each category, render it
            $.each(faq_categories, function(counter, e) {
                if (parseInt(e.parent_id) === 0 && !faqApp.func.grabElement('li' + e.parent_id)) {
                    faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + '<a role="button"  ' + faqApp.func.categoryUri(e.id) + ' id="faq_category_id_' + e.id + '" faq-data="ajax-category" class="faq_nav_inactive"><li id="faq_li_id_' + e.id + '" class="faq--toplevel-nosub">' + e.name + '</li></a>';
                } else {
                    if (faqApp.func.grabElement('faq_ul_id_' + e.parent_id)) {
                        faqApp.func.grabElement('faq_ul_id_' + e.parent_id).innerHTML = faqApp.func.grabElement('faq_ul_id_' + e.parent_id).innerHTML + '<a role="button" ' + faqApp.func.categoryUri(e.id) + ' id="faq_category_id_' + e.id + '" faq-data="ajax-category" class="faq_nav_inactive"><li id="faq_li_id_' + e.id + '">' + e.name + '</li></a>';
                    } else {
                        faqApp.func.grabElement('faq_li_id_' + e.parent_id).innerHTML = faqApp.func.grabElement('faq_li_id_' + e.parent_id).innerHTML + '<ul id="faq_ul_id_' + e.parent_id + '" class="ul-hide"><a role="button" ' + faqApp.func.categoryUri(e.id) + ' id="faq_category_id_' + e.id + '" faq-data="ajax-category" class="faq_nav_inactive"><li id="faq_li_id_' + e.id + '" >' + e.name + '</li></a></ul>';
                        faqApp.func.grabElement('faq_li_id_' + e.parent_id).setAttribute("class", "faq--topelevel-category");
                    }
                }
            });
            // Test new payment methods
            if(faqApp.vars.brand == 'dvb')
            {
              faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + `<a href="https://in.betsson.com/payment-methods/en/" target="_blank" id="payment_methods_link" class="faq_nav_inactive"> <li>Payment Methods</li> </a>`;
            }

            // add cookie settings link at the end of categories for non OneTrust enabled brands. Betsafe colorado no cookie settings
            if(!(faqApp.oneTrust.permit) && !(faqApp.vars.brand == 'bsf-crd' || faqApp.vars.brand == 'bsf-ont'))
            {
                faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + `<a href="${faq_info.url_cookiesettings}" target="_blank" id="cookie_settings_link" class="faq_nav_inactive" onclick="faqApp.func.cookiesAcknowledged(0);"> <li>${faqApp.obj.translation.gdpr_settings}</li> </a>`;
            }
            // Testing OneTrust on DevBrand 21
            if(faqApp.oneTrust.permit)
            {
                // faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + `<a role="button" id="cookie_settings_link" class="ot-sdk-show-settings faq_nav_inactive">${faqApp.obj.translation.gdpr_settings}</a>`;
                faqApp.func.grabElement('faq_app_categorybox').innerHTML = faqApp.func.grabElement('faq_app_categorybox').innerHTML + `<a role="button id="cookie_settings_link" class="faq_nav_inactive" onclick="OneTrust.ToggleInfoDisplay();"> <li>${faqApp.obj.translation.gdpr_settings}</li> </a>`;
            }

            faqApp.func.grabElement('faq_app_categorybox').innerHTML = '<nav class="faq--navigation"><ul>' + faqApp.func.grabElement('faq_app_categorybox').innerHTML + '</ul></nav>';
        }
        if (faqApp.func.grabElement('faq_app_searchbox')) {
            faqApp.func.grabElement('faq_app_searchbox').innerHTML = '<div class="faq--searchbox"><section class="faq--searchwrapper"><input type="text" class="faq--searchinput" id="faq_textinput_id" placeholder="' + faqApp.obj.translation.search_field_lbl + '" value="" required><button id="faq_searchbtn_id" class="faq--searchbutton"><i class="fa fa-search"></i></button></section></div>';
        }
        // if not greek
        if (faqApp.func.grabElement('faq_app_toptenbox') && faq_topten && faqApp.vars.language != 'gr') {
            if (faq_topten.error) {
                faqApp.func.grabElement('faq_app_toptenbox').innerHTML = '<h1>' + faqApp.obj.translation.topten_faq_lbl + '</h1><p>' + faq_topten.error + '</p>';
            } else {
                var list = "";
                $.each(faq_topten.id, function(k, d) {
                    list = list + '<a role="button" ' + faqApp.func.faqUri(d) + ' id="faq_topten_id_' + d + '" faq-data="ajax-faq"><li>' + faq_topten.title[k] + '</li></a>';
                });
                faqApp.vars.topten = '<h1>' + faqApp.obj.translation.topten_faq_lbl + '</h1><ol>' + list + '</ol>';
                faqApp.func.grabElement('faq_app_toptenbox').innerHTML = faqApp.vars.topten;
            }
        }
        // if greek
        if (faqApp.func.grabElement('faq_app_toptenbox') && faq_topten && faqApp.vars.language == 'gr') {
            if (faq_topten.error) {
                faqApp.func.grabElement('faq_app_toptenbox').innerHTML = '<h1 lang="el">' + faqApp.obj.translation.topten_faq_lbl + '</h1><p>' + faq_topten.error + '</p>';
            } else {
                var list = "";
                $.each(faq_topten.id, function(k, d) {
                    list = list + '<a role="button" ' + faqApp.func.faqUri(d) + ' id="faq_topten_id_' + d + '" faq-data="ajax-faq"><li>' + faq_topten.title[k] + '</li></a>';
                });
                faqApp.vars.topten = '<h1 lang="el">' + faqApp.obj.translation.topten_faq_lbl + '</h1><ol>' + list + '</ol>';
                faqApp.func.grabElement('faq_app_toptenbox').innerHTML = faqApp.vars.topten;
            }
        }

        if (faqApp.obj.uri[faqApp.obj.uri.faquri]) {
            faqApp.func.openFaq(faqApp.obj.uri[faqApp.obj.uri.faquri]);
        }
        if (faqApp.obj.uri[faqApp.obj.uri.categoryuri]) {
            faqApp.func.faqsPerCategory(faqApp.obj.uri[faqApp.obj.uri.categoryuri]);
        }
        if (faqApp.obj.uri[faqApp.obj.uri.searchuri]) {
            var faq_searchobj = {
                faqsearch: faqApp.obj.uri[faqApp.obj.uri.searchuri]
            };
            faqApp.func.search(faq_searchobj);
            faqApp.func.grabElement('faq_textinput_id').value = decodeURI(faqApp.obj.uri[faqApp.obj.uri.searchuri]);
        }
    }
    if (window.location.search) {
        if (faqApp.obj.uri.category && typeof faqApp.obj.uri.category === 'string' && faqApp.obj.uri.category.length > 3) {
            url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getCategory&categoryName=';
            faqApp.func.ajax(url + faqApp.obj.uri.category.replace(/-/g, '%20'), null, true, function(data) {
                if (data.length > 0)
                    faqApp.func.render(true, data, 2);
            });
        }
        if (faqApp.obj.uri.faq && typeof faqApp.obj.uri.faq === 'string' && faqApp.obj.uri.faq.length > 0) {
            url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getFaq&recordId=';
            faqApp.func.ajax(url + parseInt(faqApp.obj.uri.faq), null, true, function(data) {
                if (data.id) {
                    faqApp.func.grabElement('faq_app_renderbox').innerHTML = faqApp.func.resultFaq(data);
                    if ($('#launchsaform').length > 0) {
                        if (typeof faqApp.func.loadSaForm === 'function') {
                            faqApp.func.loadSaForm();
                        }
                    }
                    //Deposit Options
                    if ($('#launchdpopts').length > 0) {
                        if (typeof faqApp.func.loadDpOpts === 'function') {
                            faqApp.func.loadDpOpts();
                        }
                    }
                    //Withdrawal Options
                    if ($('#launchwdopts').length > 0) {
                        if (typeof faqApp.func.loadWdOpts === 'function') {
                            faqApp.func.loadWdOpts();
                        }
                    }
                    //ComplaintForm cache bust 10
                    if ($('#launchcomplaintform').length > 0) {
                        if (typeof faqApp.func.loadComplaintForm === 'function') {
                            faqApp.func.loadComplaintForm();
                        }
                    }
                }
            });
        }
    }
    $(document).on('click', '#mb_hamburger', function() {
        faqApp.func.hamburger();
    });
    $(document).on('keydown', '#faq_textinput_id', function(e) {
        if (e.keyCode == 13 && e.shiftKey === false) {
            faqApp.func.search(e);
            $('#faq_textinput_id').blur();
        }
    });
    $(document).on('click', '#faq_searchbtn_id', function(e) {
        faqApp.func.search(e);
    });
    $(document).on('click', 'a[faq-data="rg-info"]', function() {
        url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getCategory&categoryName=Responsible%20gaming';
        faqApp.func.ajax(url, null, true, function(data) {
            if (data.length > 0)
                faqApp.func.render(true, data, 2);
            faqApp.vars.lastfaq = 0;
            faqApp.vars.lastcat = 0;
        });
    });
    $(document).on('click', 'a[faq-data="pm-info"]', function() {
        url = '/api.php?bi=' + faqApp.vars.brand + '&device=' + faqApp.vars.device + '&action=getCategory&categoryName=Payment%20methods';
        faqApp.func.ajax(url, null, true, function(data) {
            if (data.length > 0)
                faqApp.func.render(true, data, 2);
            faqApp.vars.lastfaq = 0;
            faqApp.vars.lastcat = 0;
        });
    });
    $(document).on('click', 'a[faq-data="ajax-faq"]', function() {
        if ($(this).parent().attr('id') == undefined) {
            faqApp.func.openFaq(this, false);
        }
    });
    $(document).on('click', 'a[id^="faq_preview_link_id_"]', function() {
        const faqResultLink = document.getElementById("faq_result_id_" + faqApp.func.getId(this.id));
        if (faqResultLink) {
            faqApp.func.openFaq(faqResultLink, false);
        }
    });
    $(document).on('click', '.faq_header_button', function() {
        faqApp.vars.onSearchPage = false;
        faqApp.func.openFaq(this, true);
        faqApp.func.disableSearchRequestLock();
    });
    $(document).on('click', 'a[faq-data="ajax-category"]', function() {
        faqApp.func.navigation(this, false);
        faqApp.func.faqsPerCategory(this.id);
        faqApp.func.disableSearchRequestLock();
    });
    $(document).on('click', 'a[faq-data="ajax-keyword"]', function() {
        faqApp.func.keywordSearch(this.id);
    });
    // vote button
    $(document).on('click', 'div[faq-data="ajax-vote"]', function(e) {
        faqApp.func.vote(this, $(this).attr('faq-value'));
    });

    //Back Button in search function
    $(document).on('click', 'a[faq-data="object-history"]', function() {
        faqApp.vars.lastfaq = 0;
        faqApp.vars.lastcat = 0;
        faqApp.func.render(true, faqApp.obj.events.history.data, faqApp.obj.events.history.type);
        var searchPhrase = faqApp.func.grabElement('faq_textinput_id').value.trim().split(" ");
        faqApp.func.highlightWordsinDom(faqApp.func.grabElement('faq_app_renderbox'), searchPhrase);
    });
    $(document).on('click', 'a[faq-data="object-topten"]', function() {
        faqApp.func.navigation(this, false);
        faqApp.vars.lastfaq = 0;
        faqApp.vars.lastcat = 0;
        $('#faq_app_renderbox').html('<div id="faq_app_toptenbox">' + faqApp.vars.topten + '</div>');
        faqApp.func.scroll();
        if ((this.className == 'faq_nav_inactive faq_nav_active') || ($('#navigation-panel').hasClass('mb_panel_show'))) {
            faqApp.func.hamburger();
        }
        pushDatalayer(0, 0, "Most Popular FAQs", null, null, null, null, null);
        faqApp.func.disableSearchRequestLock();
    });
    $(document).on('click', 'div[faq-data="element-hide"]', function(e) {
        $('#' + $(this).attr('faq-value')).removeClass('element-show').addClass('element-hidden');
    });


    $(document).on('click', '#faq_info_whatsapp', function() {
        // Checking if on desktop or not. If desktop, the below should not fire.
        if(window.innerWidth <= 991){
            // loading spinner for slow network
            $("#callmeback_disabled").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show();

            isInterfaceOpen().then(function(result) {
              if(result)
              {
                  $("#callmeback_disabled").css(cmbDisableCSS);
                  if (faqApp.vars.brand == "stc" || faqApp.vars.brand == "dvb"){
                      window.location.href = 'https://api.whatsapp.com/send/?phone=%2B35679769801&text&type=phone_number&app_absent=0';
                  }
                  else if(faqApp.vars.brand == "bet" && faqApp.vars.language == 'pe'){
                      window.location.href = 'https://api.whatsapp.com/send/?phone=%2B35679769802&text&type=phone_number&app_absent=0';
                  }
                  else if(faqApp.vars.brand == "bet-es"){
                      window.location.href = 'https://api.whatsapp.com/send/?phone=%2B34641968621&text&type=phone_number&app_absent=0';
                  }
                  else if(faqApp.vars.brand == "bet-it"){
                      window.location.href = 'https://api.whatsapp.com/send/?phone=%2B35679769800&text&type=phone_number&app_absent=0';
                  }
                  else if(faqApp.vars.brand == "bsf-pe"){
                      window.location.href = 'https://api.whatsapp.com/send/?phone=%2B51999110254&text&type=phone_number&app_absent=0';
                  }
              }
              else{
                  $('.background_blanket').css(cmbEnableCSS);
                  $('#callmeback_disabled').html('<span class="callback_title">' + faq_info.wa_unavailable_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faq_info.wa_unavailable_text + '</p>');
                  $('#callmeback_disabled').css(cmbEnableCSS);
              }
            }).catch(function(error) {
              console.log("Error");
            });
        }
    });

    // GAM -Top buttons
    // pushDatalayer(sel, categoryId, categoryName, recordId, recordName, searchKeyword, numberOfRecords, vote);
    $(document).on('click', '#faq_info_chat', function(e) {
        recordName = "livechat";
        pushDatalayer(4, null, null, null, recordName, null, null, null);
    });
    $(document).on('click', '#faq_info_email', function(e) {
        recordName = "email";
        pushDatalayer(4, null, null, null, recordName, null, null, null);
    });
    $(document).on('click', '#faq_info_phone', function(e) {
        recordName = "phone";
        pushDatalayer(4, null, null, null, recordName, null, null, null);
    });

    progressLoader(20);
};
faqApp.func.navigation = function(e, fromRenderfunc) {
    faqApp.vars.onSearchPage = false;
    if (fromRenderfunc == false) {
        e = e.id;
    }
    if (faqApp.vars.active) {
        $('#' + faqApp.vars.active).removeClass('faq_nav_active').addClass('faq_nav_inactive');
        $('#' + e).addClass('faq_nav_active');
        faqApp.vars.active = e;
    } else {
        $('#' + e).addClass('faq_nav_active').addClass('faq_nav_inactive');
        faqApp.vars.active = e;
    }
};
faqApp.func.hamburger = function() {
    if ($('#navigation-panel')) {
        if ($('#navigation-panel').hasClass('mb_panel_show')) {
            $('#navigation-panel').removeClass('mb_panel_show').addClass('mb_panel_slide');
            $('#site').removeClass('mb_site_slide').addClass('mb_site_show');
            $('#ceu_menu').toggleClass("fa-bars");
            $('#ceu_menu').toggleClass("fa-times");

            $('#mb_hamburger.hamburger_reg').css({
                'transform': 'initial'
            });
        } else {
            $('#navigation-panel').removeClass('mb_panel_slide').addClass('mb_panel_show');
            $('#site').removeClass('mb_site_show').addClass('mb_site_slide');
            $('#ceu_menu').toggleClass("fa-bars");
            $('#ceu_menu').toggleClass("fa-times");

            //Rotate hamburger icon if certain class is present
            $('#mb_hamburger.hamburger_reg').css({
                'transform': 'rotate(90deg)'
            });
        }
    }
};
faqApp.func.scroll = function() {
    //scroll to below faq_header_row only if not already at top and more often for mobile devices
    if ($(window).scrollTop() > 50 || $(window).width() < 992) {
        if ($(window).scrollTop() > 256) {
            $(window).scrollTop($('#faq_header_row').height() + 1);
        } else {
            $("html, body").animate({
                scrollTop: ($('#faq_header_row').height() + 1)
            }, "500");
        }
    }
};

// load Self-assessment test and calculate score
faqApp.func.loadSaForm = function() {
    faqApp.vars.sascore = 0;
    $('#faq_app_renderbox').html('<div class="ajaxloader">Loading...</div>');
    $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.saForm[faqApp.vars.language], function() {
        faqApp.func.scroll();
        $(document).on('click', '#selfassessment', function() {
            var i = 0;
            var inputCount = $('#selfassessment-form input[type="radio"]').length / 4; // 4 choices per question
            $.each($('#selfassessment-form input[type="radio"]'), function() {
                if (this.checked === true) {
                    faqApp.vars.sascore += parseInt(this.value);
                    i++;
                }
            });
            if (i === inputCount) {
                $('#faq_app_renderbox').html('<div class="ajaxloader">Loading...</div>');
                $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.saResult[faqApp.vars.language], function() {
                    $('#sascore').html(faqApp.vars.sascore);
                    faqApp.func.scroll();
                });
            } else {
                faqApp.vars.sascore = 0;
            }
        });
    });
};

//load Complaint Form and send email
faqApp.func.loadComplaintForm = function() {
    $('#faq_app_renderbox').html('<div class="ajaxloader">Loading...</div>');
    $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.complaintForm[faqApp.vars.language], function() {
        faqApp.func.scroll();
        $(document).on('click', '#complaintSubmit', function() {
            $("#complaintForm").validate({
                rules: {
                    fname: "required",
                    email: {
                        required: true,
                        email: true,
                        validEmail: true
                    },
                    dob: "required",
                    incident: "required",
                    uploadedFile: "required",
                    identification: "required",
                    address: "required",
                    shortdesc: "required",
                    phone: "required",
                    amount: "required",
                    request: "required"
                },
                messages: {
                    fname: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    email: {
                        required: faqApp.obj.translation.cmb_validation_empty,
                        email: faqApp.obj.translation.cmb_validation_email,
                        validEmail: faqApp.obj.translation.cmb_validation_email
                    },
                    incident: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    uploadedFile: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    identification: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    address: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    shortdesc: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    dob: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    phone: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    amount: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    },
                    request: {
                        required: faqApp.obj.translation.cmb_validation_empty
                    }
                },
                highlight: function(el) {
                    $(el).addClass('invalid-field');
                },
                unhighlight: function(el) {
                    $(el).removeClass('invalid-field');
                },
                submitHandler: function(form) {
                    // removes default submit events and establishes AJAX call
                    event.preventDefault();
                    // show loading bars
                    $("#callmeback_confirmation").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show();
                    var form = document.getElementById("complaintForm");
                    var formMessages = $('#callmeback_confirmation');

                    var formData = new FormData();
                    formData.append("comp_id", $('#identification').val());
                    formData.append("comp_name", $('#fname').val());
                    formData.append("comp_address", $('#address').val());
                    formData.append("comp_dob", $('#dob').val());
                    formData.append("comp_email", $('#email').val());
                    formData.append("comp_subject", $('#shortdesc').val());
                    formData.append("comp_message", $('#incident').val());
                    formData.append("comp_phone", $('#phone').val());
                    formData.append("comp_amount", $('#amount').val());
                    formData.append("comp_request", $('#request').val());



                    formData.append("isComplaintForm", $('#isComplaintForm').val());
                    //File Validations and Attaching
                    var filePath = $('#uploadedFile').val();
                    var filesLength = document.getElementById('uploadedFile').files.length;
                    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.pdf)$/i;
                    var totalSize = 0;

                    if (!allowedExtensions.exec(filePath)) {
                        if(faqApp.vars.language == 'en'){
                            alert('Please upload .jpeg/.jpg/.png/.pdf files only.');
                        }
                        else if(faqApp.vars.language == 'gr'){
                            alert('Παρακαλώ ανεβάστε .jpeg/.jpg/.png/.pdf μόνο αρχεία.');
                        }
                        else if(faqApp.vars.language == 'pe'){
                            alert('Por favor, cargue solo archivos .jpeg/.jpg/.png/.pdf');
                        }
                        $('#callmeback_confirmation').hide();
                        $(".sp-circle").hide();
                        throw new Exception();
                    } else {
                        for(var i=0;i<filesLength;i++){
                            formData.append("attachment[]", document.getElementById('uploadedFile').files[i]);
                            totalSize += document.getElementById('uploadedFile').files[i].size;
                        }
                        if(totalSize > 10485760){
                            if(faqApp.vars.language == 'en'){
                                alert('File sizes are too large.');
                            }
                            else if(faqApp.vars.language == 'gr'){
                                alert('Τα μεγέθη αρχείων είναι πολύ μεγάλα.');
                            }
                            else if(faqApp.vars.language == 'pe'){
                                alert('Los tamaños de archivo son demasiado grandes.');
                            }
                            $('#callmeback_confirmation').hide();
                            $(".sp-circle").hide();
                            throw new Exception();
                        }
                    }
                    formData.append("brand", faqApp.vars.brand);
                    formData.append("lang", faqApp.vars.language);

                    for (var pair of formData.entries()) {
                        console.log(pair[0] + ', ' + pair[1]);
                    }

                    $.ajax({
                        type: 'POST',
                        timeout: 15000,
                        url: faqApp.vars.host + '/cmb.php',
                        global: false,
                        data: formData,
                        processData: false, // tell jQuery not to process the data 45
                        contentType: false, // tell jQuery not to set the content type
                        cache: false
                    }).done(function(response) {
                        // clear fields on successful submission
                        $('#complaintForm').trigger('reset');
                        if (faqApp.vars.language == 'en') {
                            $('.background_blanket').css(cmbEnableCSS);
                            // show success submission en
                            $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + "Thanks for your query" + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + "Your complaint has been submitted." + '</p></div>');
                            $(".sp-circle").hide();
                        } else if (faqApp.vars.language == 'gr') {
                            $('.background_blanket').css(cmbEnableCSS);
                            // show success submission gr
                            $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + "Σας ευχαριστούμε για το αίτημά σας" + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + "Το παράπονό σας έχει υποβληθεί." + '</p></div>');
                            $(".sp-circle").hide();
                        } else if (faqApp.vars.language == 'pe') {
                           $('.background_blanket').css(cmbEnableCSS);
                           // show success submission gr
                           $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + "Gracias por tu consulta" + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + "Su queja ha sido enviada." + '</p></div>');
                           $(".sp-circle").hide();
                        }

                    }).fail(function(data) {
                        $('.background_blanket').css(cmbEnableCSS);
                        // show error with submission
                        $('#callmeback_confirmation').html('<div id="cmb_error"><span class="callback_title">' + faqApp.obj.translation.cmb_error_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faqApp.obj.translation.cmb_error_text + '</p></div>');
                        $(".sp-circle").hide();
                    });
                    // show / hide loading spinner while waiting for ajax response
                    $(document).ajaxComplete(function() {
                        $("#cmb_loading").css("display", "none");
                    });
                }
            });
        });
    });
};

function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

//Load Deposit Method template
faqApp.func.loadDpOpts = function() {
    $('#faq_app_renderbox').html('<div class="ajaxloader">Loading...</div>');
    switch (faqApp.vars.brand) {
        case 'nrb':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.nrbDepositOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
        case 'bsf':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.bsfDepositOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
        case 'bet':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.betDepositOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
        case 'ceu':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.ceuDepositOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
        case 'nrb-dk':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.nrbDKDepositOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
    }
};

//Load Withdrawal Method template
faqApp.func.loadWdOpts = function() {
    $('#faq_app_renderbox').html('<div class="ajaxloader">Loading...</div>');
    switch (faqApp.vars.brand) {
        case 'nrb':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.nrbWithdrawalOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
        case 'bsf':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.bsfWithdrawalOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
        case 'bet':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.betWithdrawalOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
        case 'ceu':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.ceuWithdrawalOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
        case 'nrb-dk':
            $('#faq_app_renderbox').load(faqApp.obj.uri.templateUrl.nrbDKWithdrawalOptions[faqApp.vars.language], function() {
                faqApp.func.scroll();
            });
            break;
    }
};

//showing/hiding more option on deposit/withdrawal methods
function showMore(y) {
    var x = document.getElementById("payment-option-about-" + y);
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

faqApp.func.totop = function() {
    $(document).on('click', '#faq_totop', function() {
        $("html, body").animate({
            scrollTop: 0
        }, "slow");
    });
    $(document).scroll(function() {
        if ($(document).scrollTop() > 201) {
            $('#faq_totop').removeClass('faq_totop_out').addClass('faq_totop_in');
        } else {
            $('#faq_totop').removeClass('faq_totop_in').addClass('faq_totop_out');
        }
    });
};

// hide/unhide callmeback button as soon as it becomes hidden
$(document).scroll(function() {
    if (faqApp.cmb.permit) {
        if ($(document).scrollTop() > $('#faq_header_row').height()) {
            $('#faq_callmeback').removeClass('faq_callmeback_out').addClass('faq_callmeback_in');
        } else {
            $('#faq_callmeback').removeClass('faq_callmeback_in').addClass('faq_callmeback_out');
        }
    }
});

// call me back button to allow customer request a call from CS agent
var cmbEnableCSS = {
    'visibility': 'visible',
    'opacity': '1'
};
var cmbDisableCSS = {
    'visibility': 'hidden',
    'opacity': '0'
};
$(document).on('click', '#faq_callmeback, #faq_info_phone', function() {
    if (faqApp.cmb.permit) { // for CMB enabled brands / languages only
        $('.background_blanket').css(cmbEnableCSS);
        $("#callmeback_disabled").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show(); // loading spinner for slow network
        // check if enabled or disabled
        url = '/api.php?bi=' + faqApp.vars.brand + '&action=getCMBswitch';
        faqApp.func.ajax(url, null, false, function(data) {
            if (data.length > 0) {
                faqApp.cmb.on = data[0];
            }
            $("#callmeback_disabled").css(cmbDisableCSS);
            $(".sp-circle").hide(); // hide loading spinner
            if (faqApp.cmb.on == 1) {
                $('#callmeback_div').css(cmbEnableCSS); // open form - make form visible
                // $('#cmb_select').html();
                if ($(window).width() < 992) { // if on mobile device, hide floating buttons
                    $('#faq_totop').css(cmbDisableCSS);
                    $('#faq_callmeback').css(cmbDisableCSS);
                }
                // display message - "call will be held in english since customer support in this language is not available"
                if (faqApp.vars.language === "cs" || faqApp.vars.language === "pt" || faqApp.vars.language === "pt-br") {
                    $('#cmb_lang_message').html('<p>' + faqApp.obj.translation.cmb_english_call + '</p>');
                }
            } else {
                var cmb_unavailable_text = faqApp.obj.translation.cmb_unavailable_text.replace(/(\[email\])/g, "<b>" + faqApp.obj.info.info_emailaddress + "</b>");
                $('#callmeback_disabled').html('<span class="callback_title">' + faqApp.obj.translation.cmb_unavailable_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + cmb_unavailable_text + '</p>');
                $('#callmeback_disabled').css(cmbEnableCSS);
            }
        });
    }
});

//live chat button to allow customer to enter live chat form
// $(document).on('click', '#faq_info_chat', function() {
//     if (faqApp.lc.permit) { // for LC enabled brands / languages only
//         $('.background_blanket').css(cmbEnableCSS);
//         $("#callmeback_disabled").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show(); // loading spinner for slow network
//         // check if enabled or disabled
//         // url = '/api.php?bi=' + faqApp.vars.brand + '&action=getCMBswitch';
//         // faqApp.func.ajax(url, null, false, function(data){
//         //   if (data.length > 0){
//         //     faqApp.cmb.on = data[0];
//         //   }
//
//         $("#callmeback_disabled").css(cmbDisableCSS);
//         $(".sp-circle").hide(); // hide loading spinner
//         //if(faqApp.cmb.on == 1){
//         $('#livechat_div').css(cmbEnableCSS); // open form - make form visible
//         // $('#cmb_select').html();
//         if ($(window).width() < 992) { // if on mobile device, hide floating buttons
//             $('#faq_totop').css(cmbDisableCSS);
//             $('#livechat_div').css(cmbDisableCSS);
//         }
//         // display message - "call will be held in english since customer support in this language is not available"
//         // if(faqApp.vars.language === "cs" || faqApp.vars.language === "pt" || faqApp.vars.language === "pt-br"){
//         //   $('#cmb_lang_message').html('<p>'+faqApp.obj.translation.cmb_english_call+'</p>');
//         // }
//         // }else{
//         //   var cmb_unavailable_text = faqApp.obj.translation.cmb_unavailable_text.replace(/(\[email\])/g, "<b>"+faqApp.obj.info.info_emailaddress+"</b>");
//         //   $('#callmeback_disabled').html('<span class="callback_title">' + faqApp.obj.translation.cmb_unavailable_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + cmb_unavailable_text + '</p>');
//         //   $('#callmeback_disabled').css(cmbEnableCSS);
//         // }
//         //});
//     }
// });

/* check if live-chat is open or closed

faqApp.func.checkLCOpen = function(){
  var url = 'https://cscbo.mailsson.com/api/?brand=' + faqApp.vars.brand + '&language=' + faqApp.vars.language;


};*/

//live chat functionality - test dylan 5
    $(document).on('click', '#faq_info_chat', function() {
        if(window.innerWidth > 991) { // Desktop devices only
            if ((faqApp.vars.brand == 'dvb') || (faqApp.vars.brand == 'rcb-dev') || (faqApp.vars.brand == 'bsf' && faqApp.vars.language == 'cstech')) {
                $('.background_blanket').css(cmbEnableCSS);
                $("#callmeback_disabled").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show();
                $("#callmeback_disabled").css(cmbDisableCSS);
                $(".sp-circle").hide(); // hide loading spinner
                $('#live-chat-form-div').css(cmbEnableCSS); // open form - make form visible
                if ($(window).width() < 992) { // if on mobile device, hide floating buttons
                    $('#faq_totop').css(cmbDisableCSS);
                    $('#livechat_div').css(cmbDisableCSS);
                }
            }
        }
    });

//mail form show/hide Functionality
$(document).on('click', '#faq_info_email', function() {
    if (faqApp.vars.brand == 'jlc') {
        $('.background_blanket').css(cmbEnableCSS);
        $("#callmeback_disabled").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show();
        $("#callmeback_disabled").css(cmbDisableCSS);
        $(".sp-circle").hide(); // hide loading spinner
        //if(faqApp.cmb.on == 1){
        $('#mailform_div').css(cmbEnableCSS); // open form - make form visible
        // $('#cmb_select').html();
        if ($(window).width() < 992) { // if on mobile device, hide floating buttons
            $('#faq_totop').css(cmbDisableCSS);
            $('#livechat_div').css(cmbDisableCSS);
        }
    }
});


$(document).on('click', '#close_callmeback', function(event) {
    // close form - make it invisible
    faqApp.func.closeCMBform();
    faqApp.func.closeBackgroundBlanket();
});

faqApp.func.closeCMBform = function(event) {
    $('#callmeback_div').css(cmbDisableCSS);
    $('#livechat_div').css(cmbDisableCSS);
    $('#mailform_div').css(cmbDisableCSS);
    $('#live-chat-form-div').css(cmbDisableCSS);
    $("#callmeback_confirmation").css(cmbDisableCSS);
    $("#callmeback_disabled").css(cmbDisableCSS);
    // if on mobile device, show floating buttons
    if ($(window).width() < 992) {
        $('#faq_totop').css(cmbEnableCSS);
        $('#faq_callmeback').css(cmbEnableCSS);
    }
};
faqApp.func.closeBackgroundBlanket = function() {
    $('.background_blanket').css(cmbDisableCSS);
};
$(document).on('click', '#close_callmeback, .background_blanket', function(event) {
    // close form - make it invisible
    faqApp.func.closeCMBform();
    faqApp.func.closeBackgroundBlanket();
    $('#cookie_settings').css(cmbDisableCSS);

});

if (getQueryVariable("showCmb") == "true") {
    document.onload = console.log("query worked");
    if (faqApp.cmb.permit == false) { // for CMB enabled brands / languages only
        console.log("brand allowed");
        $('.background_blanket').css(cmbEnableCSS);
        $("#callmeback_disabled").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show(); // loading spinner for slow network
        // check if enabled or disabled
        url = '/api.php?bi=' + faqApp.vars.brand + '&action=getCMBswitch';
        faqApp.func.ajax(url, null, false, function(data) {
            if (data.length > 0) {
                faqApp.cmb.on = data[0];
                console.log(data[0]);
            }
            $("#callmeback_disabled").css(cmbDisableCSS);
            $(".sp-circle").hide(); // hide loading spinner
            if (faqApp.cmb.on == 1) {
                $('#callmeback_div').css(cmbEnableCSS); // open form - make form visible
                // $('#cmb_select').html();
                if ($(window).width() < 992) { // if on mobile device, hide floating buttons
                    $('#faq_totop').css(cmbDisableCSS);
                    $('#faq_callmeback').css(cmbDisableCSS);
                }
                // display message - "call will be held in english since customer support in this language is not available"
                if (faqApp.vars.language === "cs" || faqApp.vars.language === "pt" || faqApp.vars.language === "pt-br") {
                    $('#cmb_lang_message').html('<p>' + faqApp.obj.translation.cmb_english_call + '</p>');
                }
            }
        });
    }
}

// validate form
$(document).on('click', '#faq_callmeback, #faq_info_phone', function(event) {
    if (faqApp.cmb.permit) { // for CMB enabled brands / languages only
        $(".callmeback_form").validate({
            rules: {
                cmb_name: "required",
                cmb_email: {
                    required: true,
                    email: true,
                    validEmail: true
                },
                cmb_tel: {
                    required: true,
                    validTel: true
                },
                cmb_id: faqApp.vars.brand === "bet-kz" ? undefined : "required",
                cmb_message: "required",
            },
            messages: {
                cmb_name: {
                    required: faqApp.obj.translation.cmb_validation_empty
                },
                cmb_email: {
                    required: faqApp.obj.translation.cmb_validation_empty,
                    email: faqApp.obj.translation.cmb_validation_email,
                    validEmail: faqApp.obj.translation.cmb_validation_email
                },
                cmb_tel: {
                    required: faqApp.obj.translation.cmb_validation_empty,
                    validTel: faqApp.obj.translation.cmb_validation_phone
                },
                cmb_id: {
                    required: faqApp.obj.translation.cmb_validation_empty
                },
                cmb_message: {
                    required: faqApp.obj.translation.cmb_validation_empty
                }
            },
            highlight: function(el) {
                $(el).addClass('invalid-field');
            },
            unhighlight: function(el) {
                $(el).removeClass('invalid-field');
            },
            submitHandler: function(form) {
                console.log("has entered submit function");
                // removes default submit events and establishes AJAX call
                event.preventDefault();
                faqApp.func.closeCMBform();
                var brand = faqApp.vars.brand;
                // show loading bars
                $("#callmeback_confirmation").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show();
                var form = $('.callmeback_form');
                var formMessages = $('#callmeback_confirmation');
                // form to json
                var formData = {
                    cmb_name: $('#cmb_name').val(),
                    cmb_email: $('#cmb_email').val(),
                    cmb_tel: $('#cmb_tel').val(),
                    cmb_id: $('#cmb_id').val(),
                    cmb_time: $('input[name=cmb_time]:checked').val(),
                    cmb_message: $('#cmb_message').val(),
                };
                $.ajax({
                    type: 'POST',
                    timeout: 15000,
                    url: faqApp.vars.host + '/cmb.php',
                    global: false,
                    data: {
                        formData: formData,
                        brand: faqApp.vars.brand,
                        lang: faqApp.vars.language
                    }
                }).done(function(response) {
                    // clear fields on successful submission
                    $('.callmeback_form').trigger('reset');
                    // show success submission
                    $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + faqApp.obj.translation.cmb_success_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faqApp.obj.translation.cmb_success_text + '</p></div>');
                    $(".sp-circle").hide();
                }).fail(function(data) {
                    // show error with submission
                    $('#callmeback_confirmation').html('<div id="cmb_error"><span class="callback_title">' + faqApp.obj.translation.cmb_error_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faqApp.obj.translation.cmb_error_text + '</p></div>');
                    $(".sp-circle").hide();
                });
                // show / hide loading spinner while waiting for ajax response
                $(document).ajaxComplete(function() {
                    $("#cmb_loading").css("display", "none");
                });
            }
        });
    }
});

//mailform Validation
$(document).on('click', '#faq_info_email', function(event) {
    if (faqApp.vars.brand == 'jlc') {
        $(".mail_form").validate({
            rules: {
                cmb_name: "required",
                cmb_email: {
                    required: true,
                    email: true,
                    validEmail: true
                },
                // mail_dob: "required",
                cmb_message: "required",
            },
            messages: {
                cmb_name: {
                    required: faqApp.obj.translation.cmb_validation_empty
                },
                cmb_email: {
                    required: faqApp.obj.translation.cmb_validation_empty,
                    email: faqApp.obj.translation.cmb_validation_email,
                    validEmail: faqApp.obj.translation.cmb_validation_email
                },
                cmb_message: {
                    required: faqApp.obj.translation.cmb_validation_empty
                }
            },
            highlight: function(el) {
                $(el).addClass('invalid-field');
            },
            unhighlight: function(el) {
                $(el).removeClass('invalid-field');
            },
            submitHandler: function(form) {
                // removes default submit events and establishes AJAX call
                event.preventDefault();
                faqApp.func.closeCMBform();
                var brand = faqApp.vars.brand;
                // show loading bars
                $("#callmeback_confirmation").css(cmbEnableCSS).html('<div class="sp sp-circle"></div>').show();
                var form = $('.mail_form');
                var formMessages = $('#callmeback_confirmation');
                // form to json 3
                var formData = {
                    mail_id: $('#mail_id').val(),
                    mail_name: $('#mail_name').val(),
                    mail_address: $('#mail_address').val(),
                    mail_dob: $('#mail_dob').val(),
                    cmb_email: $('#mail_email').val(),
                    mail_subject: $('#mail_subject').val(),
                    mail_message: $('#mail_message').val(),
                    isMailForm: $('#isMailForm').val()
                };
                $.ajax({
                    type: 'POST',
                    timeout: 15000,
                    url: faqApp.vars.host + '/cmb.php',
                    global: false,
                    data: {
                        formData: formData,
                        brand: faqApp.vars.brand,
                        lang: faqApp.vars.language
                    }
                }).done(function(response) {
                    // clear fields on successful submission
                    $('.mail_form').trigger('reset');
                    // show success submission
                    $('#callmeback_confirmation').html('<div id="cmb_success"><span class="callback_title">' + faqApp.obj.translation.cmb_success_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faqApp.obj.translation.cmb_success_text + '</p></div>');
                    $(".sp-circle").hide();
                }).fail(function(data) {
                    // show error with submission
                    $('#callmeback_confirmation').html('<div id="cmb_error"><span class="callback_title">' + faqApp.obj.translation.cmb_error_header + '</span><i id="close_callmeback" class="fa fa-times"></i><br/><br/><p id="cmb_text">' + faqApp.obj.translation.cmb_error_text + '</p></div>');
                    $(".sp-circle").hide();
                });
                // show / hide loading spinner while waiting for ajax response
                $(document).ajaxComplete(function() {
                    $("#cmb_loading").css("display", "none");
                });
            }
        });
    }
});

//submit live chat form
$(document).on('click', '#livechat_submit', function(event) {
    //check if mobile
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var chatsource;
    if (isMobile) {
        chatsource = 161;
    } else {
        chatsource = 162;
    }
    var referralURL = document.getElementById('refUrl').value;

    var brand = document.getElementById('rn_brand').value;
    var fname = document.getElementById('LC_fname').value;
    var lname = document.getElementById('LC_lname').value;
    var email = document.getElementById('LC_email').value;
    var dob = document.getElementById('LC_DOB').value;
    var address = document.getElementById('LC_address').value;
    var product = document.getElementById('LC_product').value;
    var subject = document.getElementById('LC_subject').value;

    window.open("https://bml-en.custhelp.com/app/chat/" + faqApp.vars.brand + "/reroute?Contact.Name.First=" + encodeURI(fname) + "&Contact.ChannelUsernames.YOUTUBE.Username=" + encodeURI(lname) + "&Contact.Emails.PRIMARY.Address=" + email + "&Contact.ChannelUsernames.FACEBOOK.Username=" + dob + "&Contact.ChannelUsernames.TWITTER.Username=" + encodeURI(address) + "&Incident.Product=" + product + "&Incident.Subject=&Incident.CustomFields.c.security_verification=First%20Name:%20" + encodeURI(fname) + "Last%20Name:%" + encodeURI(lname) + "Email:%20" + email + "Birth%20Date:%20" + dob + "Address:%20" + encodeURI(address) + "&Incident.CustomFields.c.brand=" + brand + "&Incident.CustomFields.c.chat_source=" + chatsource + "&Incident.CustomFields.c.ada_chat_id=5e394ff361d03c354507e923&Incident.CustomFields.c.country_custom=&referrerUrl=" + referralURL + "", "Live-Chat", "width=200px");
});

// if an input field is touched and is invalid, an invalid class is added
$(':required').one('blur keydown', function() {
    $(this).addClass('touched');
});

// removes non-alphanumeric (except '-' and '_') and replaces spaces with '-'
faqApp.func.stringToUrl = function(phrase) {
    phrase = phrase.trim().normalize("NFKD").replace(new RegExp("[^\\p{L}0-9 _\\-/]", "gu"), '');
    phrase = phrase.replace(/[\s+\/]/g, '-').toLowerCase();
    return encodeURIComponent(phrase);
};

// loads popper.js before bootstrap, since bootstrap depends on popper.js
$(document).ready(function() {
    progressLoader(20);
    $.getScript("../assets/scripts/lib/bootstrap.min.js", function(data, textStatus, jqxhr) {}).done(function() {
        progressLoader(20);
        faqApp.func.Initialize(faqApp.obj.Initialize);
    });
});
//Betsafe-KE Closing cookie banner but not firing anything to gtm (Just for decoration)
// faqApp.func.cookieBannerClose = function(){
//   // remove cookie bars & resize view
//   $('#cookie-policy').css('display', 'none');
//   // push floating buttons back downwards
//   $('#faq_totop').css('top', $('#faq_totop').position().top + $('#cookie-policy').outerHeight());
//   $('#faq_callmeback').css('top', $('#faq_callmeback').position().top + $('#cookie-policy').outerHeight());
// };

function isInterfaceOpen() {
  var interface = whichWhatsappInterface();
  return new Promise(function(resolve, reject) {
    $.ajax({
      type: 'POST',
      timeout: 15000,
      url: faqApp.vars.host + '/chatProcess.php',
      global: false,
      data: {
        brand: interface.brand,
        language: interface.language
      },
      success: function(data) {
        $(".sp-circle").hide(); // hide loading spinner
        if (data == 1) {
          resolve(true);
        } else if (data == 0) {
          resolve(false);
        } else {
          console.log("Invalid data");
          reject(new Error("Invalid data"));
        }
      },
      error: function() {
        $(".sp-circle").hide(); // hide loading spinner
        console.log('Error calling check_openinghours function');
        reject(new Error("Error calling check_openinghours function"));
      }
    });
  });
}

// Function to identify which cscbo interface to check
function whichWhatsappInterface() {
    if (faqApp.vars.brand == "stc" && faqApp.vars.language == "it"){
        return { brand: 101, language: 19 };
    }
    if (faqApp.vars.brand == "dvb" && faqApp.vars.language == "en") {
        // Using WA_Devbrand
        return { brand: 94, language: 1 };
    }
    if(faqApp.vars.brand == "bsf" && faqApp.vars.language == "cstech"){
        // Using WA_Devbrand
        return { brand: 94, language: 1 };
    }
    if(faqApp.vars.brand == "bet" && faqApp.vars.language == "pe"){
        return { brand: 113, language: 22 };
    }
    if(faqApp.vars.brand == "bet-es" && faqApp.vars.language == "es"){
        return { brand: 119, language: 12 };
    }
    if(faqApp.vars.brand == "bet-it" && faqApp.vars.language == "it"){
        return { brand: 134, language: 19 };
    }
    if(faqApp.vars.brand == "bsf-pe" && faqApp.vars.language == "pe"){
        return { brand: 137, language: 12 };
    }
    else {
        console.log("Interface not configured");
        return { brand: null, language: null };
    }
}

function goingToAda(innerDoc){
    // the below 3 lines need to only fire when ada not supported topic
    $('#live-chat-form-div').css(cmbDisableCSS); // close form
    $('.background_blanket').css(cmbDisableCSS); // remove background blanket
    innerDoc.getElementById("preChatForm").reset(); //Refresh form
}

// Function that handles OneTrust cookie system logic
function oneTrustLogic() {
    // console.log("OneTrustLogic Fired");
    var sentAll;
    var sentFunctional;
    var sentTargeting;
    var sentPerformance;

    var oneTrustPrevious = OnetrustActiveGroups.split(",");

    if(oneTrustPrevious.includes('C0003')){
        sentFunctional = 1;
    }
    else{
        sentFunctional = 0;
    }
    if(oneTrustPrevious.includes('C0004')){
        sentTargeting = 1;
    }
    else{
        sentTargeting = 0;
    }
    if(oneTrustPrevious.includes('C0002')){
        sentPerformance = 1;
    }
    else{
        sentPerformance = 0;
    }
    if(oneTrustPrevious.includes("C0003") && oneTrustPrevious.includes("C0004") && oneTrustPrevious.includes("C0002"))
    {
        sentAll = 1;
        sentFunctional = 1;
        sentTargeting = 1;
        sentPerformance = 1;

    }
    else{
        sentAll = 0;
    }

    OneTrust.OnConsentChanged(function(){
        // console.log("ON CONSENT CHANGE FIRED");
        var oneTrustActive = OnetrustActiveGroups.split(",");
        var consent = {
            marketing: 0,
            targeting: 0,
            performance: 0,
            functional: 0
        };
        var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
        faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');

        if(oneTrustActive.includes("C0003")){
            consent.functional = 1;
            var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
            faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
        }
        if(oneTrustActive.includes("C0004")){
            consent.targeting = 1;
            consent.marketing = 1;
            var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
            faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
        }
        if(oneTrustActive.includes("C0002")){
            consent.performance = 1;

            var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
            faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
        }
        if(oneTrustActive.includes("C0005")){
            consent.marketing = 1;
            var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
            faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
        }
        if(oneTrustActive.includes("C0003") && oneTrustActive.includes("C0004") && oneTrustActive.includes("C0002") && sentAll != 1 && sentFunctional != 1 && sentTargeting != 1 && sentPerformance != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRTargetingAccepted": consent.targeting.toString(),
              "GDPRPerformanceAccepted": consent.performance.toString(),
              "GDPRFunctionalAccepted": consent.functional.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentAll = 1;
            sentFunctional = 1;
            sentTargeting = 1;
            sentPerformance = 1;
        }
        else if(oneTrustActive.includes("C0003") && oneTrustActive.includes("C0004") && sentTargeting != 1 && sentFunctional != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRTargetingAccepted": consent.targeting.toString(),
              "GDPRFunctionalAccepted": consent.functional.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentFunctional = 1;
            sentTargeting = 1;
            sentPerformance = 0;
        }
        else if(oneTrustActive.includes("C0003") && oneTrustActive.includes("C0002") && sentPerformance != 1 && sentFunctional != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRPerformanceAccepted": consent.performance.toString(),
              "GDPRFunctionalAccepted": consent.functional.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentFunctional = 1;
            sentPerformance = 1;
            sentTargeting = 0;
        }
        else if(oneTrustActive.includes("C0004") && oneTrustActive.includes("C0002") && sentPerformance != 1 && sentTargeting != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRPerformanceAccepted": consent.performance.toString(),
              "GDPRTargetingAccepted": consent.targeting.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentPerformance= 1;
            sentTargeting = 1;
            sentFunctional = 0;
        }
        else if(oneTrustActive.includes("C0003") && sentFunctional != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRFunctionalAccepted": consent.functional.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentFunctional = 1;
        }
        else if(oneTrustActive.includes("C0004") && sentTargeting != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRTargetingAccepted": consent.targeting.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentTargeting = 1;
        }
        else if(oneTrustActive.includes("C0002") && sentPerformance != 1)
        {
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRPerformanceAccepted": consent.performance.toString(),
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
            sentPerformance = 1;
        }
        else
        {
            dataLayer.push({
              "gdpr_performance_enabled": consent.performance.toString(),
              "gdpr_targeting_enabled": consent.targeting.toString(),
              "gdpr_functional_enabled": consent.functional.toString()
            });
        }
        if(oneTrustActive.includes('C0003')){
            sentFunctional = 1;
        }
        else{
            sentFunctional = 0;
        }
        if(oneTrustActive.includes('C0004')){
            sentTargeting = 1;
        }
        else{
            sentTargeting = 0;
        }
        if(oneTrustActive.includes('C0002')){
            sentPerformance = 1;
        }
        else{
            sentPerformance = 0;
        }
        if((sentFunctional == 1) && (sentTargeting == 1) && (sentPerformance == 1))
        {
            sentAll = 1;
        }
        else{
            sentAll = 0;
        }
    });
}

// GDPR - cookies consent (yes clicked)
faqApp.func.cookiesAcknowledged = function(value) {
    // generate cookie so snackbar doesn't show again
    // 0: marketing tags NOT allowed ('cookie settings' link pressed) - GTM set to FALSE
    // 1: marketing tags allowed ('ACCEPT' button pressed) - GTM set to TRUE
    consent = {
        marketing: value,
        targeting: value,
        performance: value,
        functional: value
    };
    var cname = `${encodeURIComponent(JSON.stringify(consent))}`;
    faqApp.func.setCookie('CONSENT', cname, 2, faqApp.vars.secondLevelDomain, '/');
    if (value == 1) {
        // push marketing consent to GTM
        pushDatalayer(5, null, null, null, null, null, null, null);
        // OneTrust Hybrid
        pushDatalayer(7, null, null, null, null, null, null, null);
    }
    else if (value == 0){
        pushDatalayer(8, null, null, null, null, null, null, null);
    }
    // remove cookie bars & resize view
    $('#cookie-policy').css('display', 'none');
    // push floating buttons back downwards
    $('#faq_totop').css('top', $('#faq_totop').position().top + $('#cookie-policy').outerHeight());
    $('#faq_callmeback').css('top', $('#faq_callmeback').position().top + $('#cookie-policy').outerHeight());
};

// set cookie with name, value, expiry date, domain
faqApp.func.setCookie = function(key, value, expiry, domain, path) {
    var date = new Date();
    date.setTime(date.getTime() + (31536000000 * expiry)); // current time + (365 days * no. of years)
    document.cookie = `${key}=${value};expires=${date.toUTCString()};domain=${domain};path=${path}`;
};

// get value of cookie
faqApp.func.getCookie = function(key) {
    var value = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
    return value ? value[2] : null;
};

var progressLoader = (function(a) {
    var progress = 10;
    if (progress < 100) {
        return function(a) {
            if ($('#ajaxProgressBar')) {
                $('#ajaxProgressBar').css({
                    width: (progress + a) + '%'
                }).attr('aria-valuenow', (progress + a));
            }
            if ((progress + a) >= 100) {
                $('#ajaxProgress').css({
                    transition: "all 0.5s",
                    opacity: 0,
                });
                setTimeout(function() {
                    $('#ajaxProgress').remove();
                    // document.getElementById('snow-div').style.display = 'block';
                }, 500);
            }
            return progress += a;
        };
    }
})();


// pushing data to dataLayer googletagmanager 5
pushDatalayer = function(sel, categoryId, categoryName, recordId, recordTitle, searchKeyword, numberOfRecords, vote) {
    var recordTitleUrl = "";
    var categoryNameUrl = "";

    if (recordTitle !== null) {
        recordTitleUrl = faqApp.func.stringToUrl(recordTitle);
    }
    if (categoryName !== null) {
        categoryNameUrl = faqApp.func.stringToUrl(categoryName);
    }

    switch (sel) {
        // category click - virtualPageView
        case 0: {
            dataLayer.push({
                "event": "virtualPageView",
                "VirtualTitle": "Help Centre | Category | " + categoryName,
                "VirtualUrl": "/" + faqApp.vars.language + "/category/" + categoryNameUrl
            });
            break;
        }

        // record click - virtualPageView
        case 1: {
            baseRecordUrl = "/" + faqApp.vars.language;
            if (categoryName == 'Quick Link') {
                baseRecordUrl += '/quicklink';
            }
            // on search page?
            if (faqApp.vars.onSearchPage === true) {
                categoryName = "Search Results";
                baseRecordUrl += "/search-results";
            }

            baseRecordUrl += "/faq/";

            dataLayer.push({
                "event": "virtualPageView",
                "VirtualTitle": "Help Centre | " + recordTitle,
                "VirtualUrl": baseRecordUrl + recordTitleUrl,
                "Area": "Customer Service",
                "cs_lobby_faq_category": categoryName,
                "cs_lobby_faq_id": recordId
            });
            break;
        }

        // search click - event
        case 2: {

            var rfc5322RegExp = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi);
            if (rfc5322RegExp.test(searchKeyword)) {
                searchKeyword = searchKeyword.replace(rfc5322RegExp, '[email-address]');
            }

            dataLayer.push({
                "event": "search",
                "cs_lobby_keyword": searchKeyword,
                "cs_lobby_number_of_results": numberOfRecords,
                "VirtualUrl": "/" + faqApp.vars.language + "/search?w=" + searchKeyword
            });
            break;
        }

        // Vote click - event
        case 3: {
            dataLayer.push({
                "event": "vote",
                "cs_lobby_faq_id": recordId,
                "cs_lobby_faq_name": recordTitle, // top fix
                "cs_lobby_faq_vote": vote, // yes / no
            });
            break;
        }

        // faq_info button link
        case 4: {
            dataLayer.push({
                "event": "cs_lobby_external_link",
                "cs_lobby_external_link_destination": recordTitle,
                "VirtualUrl": "/" + faqApp.vars.language + "/" + recordTitleUrl
            });
            break;
        }
        // fired when marketing consent is set
        case 5: {
            dataLayer.push({
                "event": "MarketingConsent"
            });
            break;
        }
        // Testing main page tracking
        case 6:
          dataLayer.push({
            "event": "virtualPageView",
            "VirtualTitle": "Help Centre",
            "VirtualUrl": "/" + faqApp.vars.language
          });
          break;
          // Testing OneTrust - When user ACCEPTS all cookies
          case 7:
            dataLayer.push({
              "event": "GDPRConsent",
              "GDPRTargetingAccepted": "1",
              "GDPRPerformanceAccepted": "1",
              "GDPRFunctionalAccepted": "1",
              "gdpr_performance_enabled": "1",
              "gdpr_targeting_enabled": "1",
              "gdpr_functional_enabled": "1"
            });
            break;
            // Testing OneTrust - When user DECLINES all cookies
            case 8:
              dataLayer.push({
                "event": "GDPRConsent",
                "GDPRTargetingAccepted": "0",
                "GDPRPerformanceAccepted": "0",
                "GDPRFunctionalAccepted": "0",
                "gdpr_performance_enabled": "0",
                "gdpr_targeting_enabled": "0",
                "gdpr_functional_enabled": "0"
              });
              break;
    }
};
